// tslint:disable
import { Injectable } from '@angular/core';

import { DwQuery, DwQueryBuilderGen, DwItem2, DwItemAttributeCollection, DwItemAttribute, DwItemRelationshipCollection, DwItemRelationship, DwItemDetail2, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.44
   Code Gen Name   Fleet
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     10/3/2024 12:17:31 PM
************************************************/

export enum FleetMetaDataItemNames {
    Auction = 'Auction',
    BidHistory = 'BidHistory',
    CodeValue = 'CodeValue',
    DepartmentMap = 'DepartmentMap',
    EmployeeServiceDates = 'EmployeeServiceDates',
    EthosCodeValue = 'Ethos_CodeValue',
    EthosCodeValueCustom = 'Ethos_CodeValueCustom',
    EthosJobNumber = 'Ethos_JobNumber',
    EthosJobNumberForecast = 'Ethos_JobNumberForecast',
    EthosJobNumberMembership = 'Ethos_JobNumberMembership',
    EthosJobNumberPhase = 'Ethos_JobNumberPhase',
    EthosJobNumberPriority = 'Ethos_JobNumberPriority',
    EthosServiceUser = 'Ethos_ServiceUser',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    EthosWachterDepartment = 'Ethos_WachterDepartment',
    FleetVehicle = 'fleet_Vehicle',
    Maintenance = 'Maintenance',
    MaintenanceService = 'MaintenanceService',
    PafHistory = 'PafHistory',
    RoAuction = 'roAuction',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoMaintenance = 'roMaintenance',
    RoVehicle = 'roVehicle',
    RoVehicleAccidents = 'roVehicleAccidents',
    RoVehicleYears = 'roVehicleYears',
    ServiceType = 'ServiceType',
}

export enum FleetMetaDataLookups {
    ActiveJobNumberForKickoff = 2934,
    AuctionAllItems = 2939,
    BidHistoryAllItems = 2942,
    CodeValueAccessControl = 2811,
    CodeValueAccessControlAdditionalOptions = 1849,
    CodeValueCCTVTypesOfInstall = 1851,
    CodeValueCompanyLicenseStatus = 2877,
    CodeValueDifferentTypeOfElectrical = 1846,
    CodeValueElectricalNewWorkType = 1848,
    CodeValueEquipmentRequestJobContext = 2995,
    CodeValueFireAlarmDemoOrInstall = 1850,
    CodeValueFleetAuctionStatus = 2954,
    CodeValueFleetAuctionStatusActive = 2964,
    CodeValueFleetAuctionStatusCompleted = 2965,
    CodeValueFleetAuctionStatusNotStarted = 2963,
    CodeValueFleetDriveTrain = 2947,
    CodeValueFleetFuelType = 2948,
    CodeValueFleetOwnershipType = 2945,
    CodeValueFleetVehicleCondition = 2949,
    CodeValueFleetVehicleStatus = 2944,
    CodeValueFleetVehicleType = 2946,
    CodeValueInspectionState = 1866,
    CodeValueInspectionTimeOfDay = 1863,
    CodeValueLicenseStatus = 1467,
    CodeValueMORSubTypeByIssueType = 1513,
    CodeValuePassFail = 1867,
    CodeValuePerformWork = 1803,
    CodeValuePermitCableType = 1799,
    CodeValuePermitRequestAddAction = 2865,
    CodeValuePermitRequestElectricalOutletType = 1845,
    CodeValuePermitRequestType = 1798,
    CodeValuePermitStatus = 1801,
    CodeValueTypesOfElectrical = 1847,
    CodeValueVehicleAccidentFormVersion = 3000,
    CodeValueVehicleAccidentLineOfBusiness = 3001,
    CodeValueAccidentType = 1541,
    CodeValueAccidentTypeWorkplace = 1648,
    CodeValueAirportPlan = 1596,
    CodeValueAtFault = 1542,
    CodeValueBodyPart = 1684,
    CodeValueBodySide = 1685,
    CodeValueBusinessPlanReviewAccidentType = 1587,
    CodeValueClaimStatus = 1544,
    CodeValueEmployeeTrainingNeeded = 1525,
    CodeValueEmployeeTrainingNeededConclusion = 1532,
    CodeValueEmployeeTrainingNeededStatus = 1534,
    CodeValueEmsWorkStatus = 1638,
    CodeValueEquipmentDelivery = 1453,
    CodeValueEthosJobNumberType = 2868,
    CodeValueEthosSkill = 2840,
    CodeValueFiveStarRatingValue = 1616,
    CodeValueInjuryType = 1683,
    CodeValueInspectionResults = 1869,
    CodeValueInsuranceCompany = 1545,
    CodeValueJobType = 2821,
    CodeValueLodgingPlan = 1598,
    CodeValueMemoOfRecordIssueSubTypeAll = 1515,
    CodeValueMemoOfRecordConclusion = 1511,
    CodeValueMemoOfRecordEmployeeType = 1510,
    CodeValueMemoOfRecordIssueType = 1512,
    CodeValueMORStatus = 1517,
    CodeValuePayJobChangeDepartmentRole = 1485,
    CodeValuePayJobChangeStatus = 1481,
    CodeValuePayJobChangeType = 1486,
    CodeValuePermitTeam = 1731,
    CodeValuePermitType = 1726,
    CodeValuePlenumOrRiser = 1727,
    CodeValueTechType = 1586,
    CodeValueTermResignType = 1487,
    CodeValueTransportationPlan = 1597,
    CodeValueTravelMode = 1595,
    CodeValueTravelRequestStatus = 1601,
    CodeValueTravelType = 1599,
    CodeValueVechicleRepaired = 1543,
    CodeValueWorkerType = 1792,
    CodeValueWorkersCompClaimStatus = 2862,
    CodeValueWorksiteType = 1647,
    DepartmentMapAllItems = 2968,
    EmployeesByDeptIncTrainees = 2812,
    EmployeeServiceDatesAllItems = 1625,
    EthosInvoiceDeliveryType = 1707,
    EthosUserTypeCodeValue = 1690,
    EthosCodeValueAllItems = 1631,
    EthosCodeValueCustomAllItems = 1733,
    EthosJobNumberActiveOnlyForKickoff = 1750,
    EthosJobNumberEJNPJNFJN = 2869,
    EthosJobNumberAllItems = 1378,
    EthosJobNumberEndDate = 1504,
    EthosJobNumberForecastAllItems = 1377,
    EthosJobNumberMembershipAllItems = 2867,
    EthosJobNumberPhaseAllItems = 1588,
    EthosJobNumberPriorityAllItems = 2866,
    EthosServiceUserAllItems = 1774,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserNSPUsers = 2981,
    EthosUserEmployeeGroups = 2858,
    EthosUserDiffAllItems = 1623,
    EthosUserSkillAllItems = 1413,
    EthosWachterDepartmentByDivision = 2991,
    EthosWachterDepartmentAllItems = 1391,
    EthosWachterDepartmentAllItemsSimple = 2994,
    FleetAuctionStatusWorkflow = 2979,
    FleetMaintenanceDriver = 2966,
    FleetMaintenancePlate = 2975,
    FleetVehicleActiveUnitsOnly = 2957,
    FleetVehicleDriver = 2951,
    FleetVehicleDriverAlert = 2989,
    FleetVehicleFuelCard = 2988,
    FleetVehiclePlate = 2973,
    FleetVehiclePlateExpiration = 2974,
    FleetVehicleUnitID = 2950,
    FleetVehicleUnitsAll = 2967,
    FleetVehicleVIN = 2972,
    FleetVehicleYears = 2952,
    JobNumberActive = 1872,
    JobNumberToCustJobName = 2870,
    MaintenanceAllItems = 2937,
    MaintenanceServiceAllItems = 2958,
    NoAuctionFleetVehicles = 2990,
    OverheadJobNumbers = 1589,
    OverheadJobNumbersActive = 2962,
    PafHistoryAllItems = 2941,
    PermitJobTypeLookup = 1811,
    PermitRequestJobTypeLookupNoJobNumber = 1873,
    Permitv2JobTypeLookupNoJobNumber = 2845,
    PlenumRiseOutdoor = 1796,
    ProjectKickoffBillingFrequency = 2923,
    ProjectKickoffBillingType = 2922,
    ProjectKickoffJobNumberFromOpportunity = 2931,
    RoAuctionAllItems = 2955,
    RoEthosUserActiveOnly = 2837,
    RoEthosUserAllActiveThenInactive = 2889,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    RoMaintenanceAllItems = 2956,
    RoVehicleAllItems = 2943,
    RoVehicleAccidentsAllItems = 1552,
    RoVehicleYearsAllItems = 2907,
    ServiceTypesAllAlphabetical = 2960,
    ServiceTypeAllItems = 2959,
    TrustCodeValueAllItems = 1388,
    VehicleAllItems = 2936,
    VehicleYears = 2908,
    WachterDivisions = 1858,
}


// Generated Classes for MetaData service
export class AuctionMetaData implements DwItem2<AuctionEntity, AuctionMetaDataAttributes,AuctionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3434;
        this.ItemDetail.itemName='Auction';
        this.ItemDetail.keyName='AuctionId';
    }

    CreateEntity(): AuctionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): AuctionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<AuctionEntity, AuctionMetaDataAttributes,AuctionMetaDataRelations>(query, this);
    }
     Attributes = new AuctionMetaDataAttributes();
     Relations = new AuctionMetaDataRelations();

}


export type AuctionQueryBuilder = DwQueryBuilderGen<AuctionEntity, AuctionMetaDataAttributes,AuctionMetaDataRelations>


export class AuctionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Auction';
    // Attributes
    AuctionId = new DwItemAttribute(this.i, 'AuctionId');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    ModifiedByUserId = new DwItemAttribute(this.i, 'ModifiedByUserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    SharepointId = new DwItemAttribute(this.i, 'SharepointId');
    VehicleId = new DwItemAttribute(this.i, 'VehicleId');
    Color = new DwItemAttribute(this.i, 'Color');
    Mileage = new DwItemAttribute(this.i, 'Mileage');
    ConditionCv = new DwItemAttribute(this.i, 'ConditionCv');
    Duration = new DwItemAttribute(this.i, 'Duration');
    LegacyUnitId = new DwItemAttribute(this.i, 'LegacyUnitId');
    Description = new DwItemAttribute(this.i, 'Description');
    StatusCv = new DwItemAttribute(this.i, 'StatusCv');
    LocationCity = new DwItemAttribute(this.i, 'LocationCity');
    LocationStateProvinceId = new DwItemAttribute(this.i, 'LocationStateProvinceId');
    LocationZip = new DwItemAttribute(this.i, 'LocationZip');
    StartingPrice = new DwItemAttribute(this.i, 'StartingPrice');
    StartDateTime = new DwItemAttribute(this.i, 'StartDateTime');
    FinalPrice = new DwItemAttribute(this.i, 'FinalPrice');
    NoteParentId = new DwItemAttribute(this.i, 'NoteParentId');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    Title = new DwItemAttribute(this.i, 'Title');
    EndDateTime = new DwItemAttribute(this.i, 'EndDateTime');
}

class AuctionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Trust Code Value - Condition */
            CodeValueByConditionCv = new DwItemRelationship('CodeValue|Auction|ConditionCv', 'ConditionCvCodeValue', 'ConditionCvCodeValue');
            /** Relation: Trust Code Value - Status */
            CodeValueByStatusCv = new DwItemRelationship('CodeValue|Auction|StatusCv', 'StatusCvCodeValue', 'StatusCvCodeValue');
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId = new DwItemRelationship('Ethos_User|Auction|CreatedByUserId', 'CreatedByEthosUser', 'CreatedByEthosUser');
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId = new DwItemRelationship('Ethos_User|Auction|ModifiedByUserId', 'ModifiedByEthosUser', 'ModifiedByEthosUser');
            /** Relation: Vehicle */
            FleetVehicle = new DwItemRelationship('fleet_Vehicle|Auction|VehicleId', 'FleetVehicle', 'FleetVehicle');
            /** Relation: Bid History */
            BidHistory = new DwItemRelationship('Auction|BidHistory|AuctionId', 'BidHistory', 'BidHistory');
            /** Relation: Ro Auction */
            RoAuction = new DwItemRelationship('roAuction|Auction|AuctionId', 'RoAuction', 'RoAuction');
    };
export class BidHistoryMetaData implements DwItem2<BidHistoryEntity, BidHistoryMetaDataAttributes,BidHistoryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3437;
        this.ItemDetail.itemName='BidHistory';
        this.ItemDetail.keyName='BidHistoryId';
    }

    CreateEntity(): BidHistoryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): BidHistoryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<BidHistoryEntity, BidHistoryMetaDataAttributes,BidHistoryMetaDataRelations>(query, this);
    }
     Attributes = new BidHistoryMetaDataAttributes();
     Relations = new BidHistoryMetaDataRelations();

}


export type BidHistoryQueryBuilder = DwQueryBuilderGen<BidHistoryEntity, BidHistoryMetaDataAttributes,BidHistoryMetaDataRelations>


export class BidHistoryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'BidHistory';
    // Attributes
    BidHistoryId = new DwItemAttribute(this.i, 'BidHistoryId');
    AuctionId = new DwItemAttribute(this.i, 'AuctionId');
    BidderName = new DwItemAttribute(this.i, 'BidderName');
    Amount = new DwItemAttribute(this.i, 'Amount');
    Notes = new DwItemAttribute(this.i, 'Notes');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    AppUserId = new DwItemAttribute(this.i, 'AppUserId');
}

class BidHistoryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Auction */
            Auction = new DwItemRelationship('Auction|BidHistory|AuctionId', 'Auction', 'Auction');
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId = new DwItemRelationship('Ethos_User|BidHistory|CreatedByUserId', 'CreatedByEthosUser', 'CreatedByEthosUser');
    };
export class CodeValueMetaData implements DwItem2<CodeValueEntity, CodeValueMetaDataAttributes,CodeValueMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2385;
        this.ItemDetail.itemName='CodeValue';
        this.ItemDetail.keyName='CodeValueId';
    }

    CreateEntity(): CodeValueEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): CodeValueQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<CodeValueEntity, CodeValueMetaDataAttributes,CodeValueMetaDataRelations>(query, this);
    }
     Attributes = new CodeValueMetaDataAttributes();
     Relations = new CodeValueMetaDataRelations();

}


export type CodeValueQueryBuilder = DwQueryBuilderGen<CodeValueEntity, CodeValueMetaDataAttributes,CodeValueMetaDataRelations>


export class CodeValueMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'CodeValue';
    // Attributes
    CodeValueId = new DwItemAttribute(this.i, 'CodeValueId');
    CodeSetId = new DwItemAttribute(this.i, 'CodeSetId');
    Display = new DwItemAttribute(this.i, 'Display');
    Meaning = new DwItemAttribute(this.i, 'Meaning');
    Description = new DwItemAttribute(this.i, 'Description');
    CodeValueOrder = new DwItemAttribute(this.i, 'CodeValueOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
}

class CodeValueMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Auction - Condition Cv - Many */
            AuctionByConditionCv = new DwItemRelationship('CodeValue|Auction|ConditionCv', 'ConditionCvAuction', 'ConditionCvAuction');
            /** Relation: Auction - Status Cv - Many */
            AuctionByStatusCv = new DwItemRelationship('CodeValue|Auction|StatusCv', 'StatusCvAuction', 'StatusCvAuction');
            /** Relation: Vehicle - Vehicle Status Cv - Many */
            FleetVehicleByVehicleStatusCv = new DwItemRelationship('CodeValue|fleet_Vehicle|VehicleStatusCv', 'VehicleStatusCvFleetVehicle', 'VehicleStatusCvFleetVehicle');
            /** Relation: Vehicle - Vehicle Type Cv - Many */
            FleetVehicleByVehicleTypeCv = new DwItemRelationship('CodeValue|fleet_Vehicle|VehicleTypeCv', 'VehicleTypeCvFleetVehicle', 'VehicleTypeCvFleetVehicle');
            /** Relation: Vehicle - Ownership Type Cv - Many */
            FleetVehicleByOwnershipTypeCv = new DwItemRelationship('CodeValue|fleet_Vehicle|OwnershipTypeCv', 'OwnershipTypeCvFleetVehicle', 'OwnershipTypeCvFleetVehicle');
            /** Relation: Vehicle - Drive Train Cv - Many */
            FleetVehicleByDriveTrainCv = new DwItemRelationship('CodeValue|fleet_Vehicle|DriveTrainCv', 'DriveTrainCvFleetVehicle', 'DriveTrainCvFleetVehicle');
    };
export class DepartmentMapMetaData implements DwItem2<DepartmentMapEntity, DepartmentMapMetaDataAttributes,DepartmentMapMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3443;
        this.ItemDetail.itemName='DepartmentMap';
        this.ItemDetail.keyName='DepartmentMapId';
    }

    CreateEntity(): DepartmentMapEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): DepartmentMapQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<DepartmentMapEntity, DepartmentMapMetaDataAttributes,DepartmentMapMetaDataRelations>(query, this);
    }
     Attributes = new DepartmentMapMetaDataAttributes();
     Relations = new DepartmentMapMetaDataRelations();

}


export type DepartmentMapQueryBuilder = DwQueryBuilderGen<DepartmentMapEntity, DepartmentMapMetaDataAttributes,DepartmentMapMetaDataRelations>


export class DepartmentMapMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'DepartmentMap';
    // Attributes
    DepartmentMapId = new DwItemAttribute(this.i, 'DepartmentMapId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    Group = new DwItemAttribute(this.i, 'Group');
}

class DepartmentMapMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_WachterDepartment|DepartmentMap|WachterDepartmentId', 'EthosWachterDepartment', 'EthosWachterDepartment');
    };
export class EmployeeServiceDatesMetaData implements DwItem2<EmployeeServiceDatesEntity, EmployeeServiceDatesMetaDataAttributes,EmployeeServiceDatesMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2574;
        this.ItemDetail.itemName='EmployeeServiceDates';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): EmployeeServiceDatesEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EmployeeServiceDatesQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EmployeeServiceDatesEntity, EmployeeServiceDatesMetaDataAttributes,EmployeeServiceDatesMetaDataRelations>(query, this);
    }
     Attributes = new EmployeeServiceDatesMetaDataAttributes();
     Relations = new EmployeeServiceDatesMetaDataRelations();

}


export type EmployeeServiceDatesQueryBuilder = DwQueryBuilderGen<EmployeeServiceDatesEntity, EmployeeServiceDatesMetaDataAttributes,EmployeeServiceDatesMetaDataRelations>


export class EmployeeServiceDatesMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeServiceDates';
    // Attributes
    PersonnelNumber = new DwItemAttribute(this.i, 'PersonnelNumber');
    HireDate = new DwItemAttribute(this.i, 'HireDate');
    EmploymentStartDate = new DwItemAttribute(this.i, 'EmploymentStartDate');
    AdjustedServiceDate = new DwItemAttribute(this.i, 'AdjustedServiceDate');
}

class EmployeeServiceDatesMetaDataRelations implements DwItemRelationshipCollection {
    };
export class EthosCodeValueMetaData implements DwItem2<EthosCodeValueEntity, EthosCodeValueMetaDataAttributes,EthosCodeValueMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2579;
        this.ItemDetail.itemName='Ethos_CodeValue';
        this.ItemDetail.keyName='CodeValueId';
    }

    CreateEntity(): EthosCodeValueEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosCodeValueQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosCodeValueEntity, EthosCodeValueMetaDataAttributes,EthosCodeValueMetaDataRelations>(query, this);
    }
     Attributes = new EthosCodeValueMetaDataAttributes();
     Relations = new EthosCodeValueMetaDataRelations();

}


export type EthosCodeValueQueryBuilder = DwQueryBuilderGen<EthosCodeValueEntity, EthosCodeValueMetaDataAttributes,EthosCodeValueMetaDataRelations>


export class EthosCodeValueMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValue';
    // Attributes
    CodeValueId = new DwItemAttribute(this.i, 'CodeValueId');
    CodeSetId = new DwItemAttribute(this.i, 'CodeSetId');
    Display = new DwItemAttribute(this.i, 'Display');
    Meaning = new DwItemAttribute(this.i, 'Meaning');
    Description = new DwItemAttribute(this.i, 'Description');
    CodeValueOrder = new DwItemAttribute(this.i, 'CodeValueOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    ImagePath = new DwItemAttribute(this.i, 'ImagePath');
}

class EthosCodeValueMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number - Invoice Delivery Type C V - Many */
            EthosJobNumberByInvoiceDeliveryTypeCV = new DwItemRelationship('Ethos_CodeValue|Ethos_JobNumber|InvoiceDeliveryTypeCV', 'InvoiceDeliveryTypeCVEthosJobNumber', 'InvoiceDeliveryTypeCVEthosJobNumber');
            /** Relation: Job Number - Forecast Status Cv - Many */
            EthosJobNumberByForecastStatusCv = new DwItemRelationship('Ethos_CodeValue|Ethos_JobNumber|ForecastStatusCv', 'ForecastStatusCvEthosJobNumber', 'ForecastStatusCvEthosJobNumber');
            /** Relation: Job Number - Job Number Type Cv - Many */
            EthosJobNumberByJobNumberTypeCv = new DwItemRelationship('Ethos_CodeValue|Ethos_JobNumber|JobNumberTypeCv', 'JobNumberTypeCvEthosJobNumber', 'JobNumberTypeCvEthosJobNumber');
            /** Relation: Ethos User - User Type Cv - Many */
            EthosUserByUserTypeCv = new DwItemRelationship('Ethos_User|Ethos_CodeValue|UserTypeCv', 'UserTypeCvEthosUser', 'UserTypeCvEthosUser');
            /** Relation: Ethos User - Resource Group Cv - Many */
            EthosUserByResourceGroupCv = new DwItemRelationship('Ethos_CodeValue|Ethos_User|ResourceGroupCv', 'ResourceGroupCvEthosUser', 'ResourceGroupCvEthosUser');
            /** Relation: User Skill - Skill Cv - Many */
            EthosUserSkillBySkillCv = new DwItemRelationship('Ethos_CodeValue|Ethos_UserSkill|SkillCv', 'SkillCvEthosUserSkill', 'SkillCvEthosUserSkill');
            /** Relation: Wachter Department - Department Type Cv - Many */
            EthosWachterDepartmentByDepartmentTypeCv = new DwItemRelationship('Ethos_CodeValue|Ethos_WachterDepartment|DepartmentTypeCv', 'DepartmentTypeCvEthosWachterDepartment', 'DepartmentTypeCvEthosWachterDepartment');
            /** Relation: Ro Ethos User - Resource Group Cv - Many */
            RoEthosUserByResourceGroupCv = new DwItemRelationship('Ethos_CodeValue|roEthos_User|ResourceGroupCv', 'ResourceGroupCvRoEthosUser', 'ResourceGroupCvRoEthosUser');
            /** Relation: Ro Ethos User - User Type Cv - Many */
            RoEthosUserByUserTypeCv = new DwItemRelationship('Ethos_CodeValue|roEthos_User|UserTypeCv', 'UserTypeCvRoEthosUser', 'UserTypeCvRoEthosUser');
    };
export class EthosCodeValueCustomMetaData implements DwItem2<EthosCodeValueCustomEntity, EthosCodeValueCustomMetaDataAttributes,EthosCodeValueCustomMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2643;
        this.ItemDetail.itemName='Ethos_CodeValueCustom';
        this.ItemDetail.keyName='CodeValueCustomId';
    }

    CreateEntity(): EthosCodeValueCustomEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosCodeValueCustomQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosCodeValueCustomEntity, EthosCodeValueCustomMetaDataAttributes,EthosCodeValueCustomMetaDataRelations>(query, this);
    }
     Attributes = new EthosCodeValueCustomMetaDataAttributes();
     Relations = new EthosCodeValueCustomMetaDataRelations();

}


export type EthosCodeValueCustomQueryBuilder = DwQueryBuilderGen<EthosCodeValueCustomEntity, EthosCodeValueCustomMetaDataAttributes,EthosCodeValueCustomMetaDataRelations>


export class EthosCodeValueCustomMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValueCustom';
    // Attributes
    CodeValueCustomId = new DwItemAttribute(this.i, 'CodeValueCustomId');
    CodeSetId = new DwItemAttribute(this.i, 'CodeSetId');
    Display = new DwItemAttribute(this.i, 'Display');
    Meaning = new DwItemAttribute(this.i, 'Meaning');
    Description = new DwItemAttribute(this.i, 'Description');
    CodeValueOrder = new DwItemAttribute(this.i, 'CodeValueOrder');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
}

class EthosCodeValueCustomMetaDataRelations implements DwItemRelationshipCollection {
    };
export class EthosJobNumberMetaData implements DwItem2<EthosJobNumberEntity, EthosJobNumberMetaDataAttributes,EthosJobNumberMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2375;
        this.ItemDetail.itemName='Ethos_JobNumber';
        this.ItemDetail.keyName='JobNumberId';
    }

    CreateEntity(): EthosJobNumberEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberEntity, EthosJobNumberMetaDataAttributes,EthosJobNumberMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberMetaDataAttributes();
     Relations = new EthosJobNumberMetaDataRelations();

}


export type EthosJobNumberQueryBuilder = DwQueryBuilderGen<EthosJobNumberEntity, EthosJobNumberMetaDataAttributes,EthosJobNumberMetaDataRelations>


export class EthosJobNumberMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber';
    // Attributes
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    JobNumberStatusWs = new DwItemAttribute(this.i, 'JobNumberStatusWs');
    JobNumberStatus = new DwItemAttribute(this.i, 'JobNumberStatus');
    JobNumber = new DwItemAttribute(this.i, 'JobNumber');
    CustomerId = new DwItemAttribute(this.i, 'CustomerId');
    JobName = new DwItemAttribute(this.i, 'JobName');
    EstimatedStartDate = new DwItemAttribute(this.i, 'EstimatedStartDate');
    EstimatedEndDate = new DwItemAttribute(this.i, 'EstimatedEndDate');
    ProjectMgr1UserId = new DwItemAttribute(this.i, 'ProjectMgr1UserId');
    ProjectMgr2UserId = new DwItemAttribute(this.i, 'ProjectMgr2UserId');
    AsstProjectMgrUserId = new DwItemAttribute(this.i, 'AsstProjectMgrUserId');
    SeniorMgrUserId = new DwItemAttribute(this.i, 'SeniorMgrUserId');
    LeadTech1UserId = new DwItemAttribute(this.i, 'LeadTech1UserId');
    LeadTech2UserId = new DwItemAttribute(this.i, 'LeadTech2UserId');
    InvoiceApproval1UserId = new DwItemAttribute(this.i, 'InvoiceApproval1UserId');
    InvoiceApproval2UserId = new DwItemAttribute(this.i, 'InvoiceApproval2UserId');
    ForecastStatusCv = new DwItemAttribute(this.i, 'ForecastStatusCv');
    ForecastStatus = new DwItemAttribute(this.i, 'ForecastStatus');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    CustomerName = new DwItemAttribute(this.i, 'CustomerName');
    CustomerShortName = new DwItemAttribute(this.i, 'CustomerShortName');
    BillingInstructions = new DwItemAttribute(this.i, 'BillingInstructions');
    ChangeOrderProcessInstructions = new DwItemAttribute(this.i, 'ChangeOrderProcessInstructions');
    PartialBilling = new DwItemAttribute(this.i, 'PartialBilling');
    FinalInvoiceDate = new DwItemAttribute(this.i, 'FinalInvoiceDate');
    InvoiceDeliveryTypeData = new DwItemAttribute(this.i, 'InvoiceDeliveryTypeData');
    InvoiceDeliveryTypeCV = new DwItemAttribute(this.i, 'InvoiceDeliveryTypeCV');
    OpportunityId = new DwItemAttribute(this.i, 'OpportunityId');
    EndCustomerId = new DwItemAttribute(this.i, 'EndCustomerId');
    LookUpKey = new DwItemAttribute(this.i, 'LookUpKey');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    JobNumberTypeCv = new DwItemAttribute(this.i, 'JobNumberTypeCv');
}

class EthosJobNumberMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos Code Value - Invoice Delivery Type */
            EthosCodeValueByInvoiceDeliveryTypeCV = new DwItemRelationship('Ethos_CodeValue|Ethos_JobNumber|InvoiceDeliveryTypeCV', 'InvoiceDeliveryTypeCVEthosCodeValue', 'InvoiceDeliveryTypeCVEthosCodeValue');
            /** Relation: Ethos Code Value - Forecast Status Cv */
            EthosCodeValueByForecastStatusCv = new DwItemRelationship('Ethos_CodeValue|Ethos_JobNumber|ForecastStatusCv', 'ForecastStatusCvEthosCodeValue', 'ForecastStatusCvEthosCodeValue');
            /** Relation: Ethos Code Value - Job Number Type */
            EthosCodeValueByJobNumberTypeCv = new DwItemRelationship('Ethos_CodeValue|Ethos_JobNumber|JobNumberTypeCv', 'JobNumberTypeCvEthosCodeValue', 'JobNumberTypeCvEthosCodeValue');
            /** Relation: Ethos User - Project Mgr1 User */
            EthosUserByProjectMgr1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|ProjectMgr1UserId', 'ProjectMgr1EthosUser', 'ProjectMgr1EthosUser');
            /** Relation: Ethos User - Project Mgr2 User */
            EthosUserByProjectMgr2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|ProjectMgr2UserId', 'ProjectMgr2EthosUser', 'ProjectMgr2EthosUser');
            /** Relation: Ethos User - Asst Project Mgr User */
            EthosUserByAsstProjectMgrUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId', 'AsstProjectMgrEthosUser', 'AsstProjectMgrEthosUser');
            /** Relation: Ethos User - Senior Mgr User */
            EthosUserBySeniorMgrUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|SeniorMgrUserId', 'SeniorMgrEthosUser', 'SeniorMgrEthosUser');
            /** Relation: Ethos User - Lead Tech1 User */
            EthosUserByLeadTech1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|LeadTech1UserId', 'LeadTech1EthosUser', 'LeadTech1EthosUser');
            /** Relation: Ethos User - Lead Tech2 User */
            EthosUserByLeadTech2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|LeadTech2UserId', 'LeadTech2EthosUser', 'LeadTech2EthosUser');
            /** Relation: Ethos User - Invoice Approval1 User */
            EthosUserByInvoiceApproval1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId', 'InvoiceApproval1EthosUser', 'InvoiceApproval1EthosUser');
            /** Relation: Ethos User - Invoice Approval2 User */
            EthosUserByInvoiceApproval2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId', 'InvoiceApproval2EthosUser', 'InvoiceApproval2EthosUser');
            /** Relation: Job Number Forecast */
            EthosJobNumberForecast = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId', 'EthosJobNumberForecast', 'EthosJobNumberForecast');
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId', 'EthosJobNumberMembership', 'EthosJobNumberMembership');
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId', 'EthosJobNumberPhase', 'EthosJobNumberPhase');
            /** Relation: Ethos Job Number Priority */
            EthosJobNumberPriority = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId', 'EthosJobNumberPriority', 'EthosJobNumberPriority');
            /** Relation: Ethos User - Project Mgr1 User - Many */
            EthosUserByUserId = new DwItemRelationship('JobNumber->ProjectManager', 'UserIdEthosUser', 'UserIdEthosUser');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_JobNumber|Ethos_WachterDepartment|JobNumberId', 'EthosWachterDepartment', 'EthosWachterDepartment');
            /** Relation: Maintenance */
            Maintenance = new DwItemRelationship('Ethos_JobNumber|Maintenance|JobNumberId', 'Maintenance', 'Maintenance');
            /** Relation: Vehicle */
            FleetVehicle = new DwItemRelationship('Ethos_JobNumber|fleet_Vehicle|JobNumberId', 'FleetVehicle', 'FleetVehicle');
    };
export class EthosJobNumberForecastMetaData implements DwItem2<EthosJobNumberForecastEntity, EthosJobNumberForecastMetaDataAttributes,EthosJobNumberForecastMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2374;
        this.ItemDetail.itemName='Ethos_JobNumberForecast';
        this.ItemDetail.keyName='JobNumberForecastId';
    }

    CreateEntity(): EthosJobNumberForecastEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberForecastQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberForecastEntity, EthosJobNumberForecastMetaDataAttributes,EthosJobNumberForecastMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberForecastMetaDataAttributes();
     Relations = new EthosJobNumberForecastMetaDataRelations();

}


export type EthosJobNumberForecastQueryBuilder = DwQueryBuilderGen<EthosJobNumberForecastEntity, EthosJobNumberForecastMetaDataAttributes,EthosJobNumberForecastMetaDataRelations>


export class EthosJobNumberForecastMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberForecast';
    // Attributes
    JobNumberForecastId = new DwItemAttribute(this.i, 'JobNumberForecastId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    YeProjectedCosts = new DwItemAttribute(this.i, 'YeProjectedCosts');
    YeProjectedRevenue = new DwItemAttribute(this.i, 'YeProjectedRevenue');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    CreatedBy = new DwItemAttribute(this.i, 'CreatedBy');
    ModifiedBy = new DwItemAttribute(this.i, 'ModifiedBy');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    Notes = new DwItemAttribute(this.i, 'Notes');
    NoteAgingOverSixtyDays = new DwItemAttribute(this.i, 'NoteAgingOverSixtyDays');
    NoteOverUnderBilling = new DwItemAttribute(this.i, 'NoteOverUnderBilling');
    NoteLowForecastedGpm = new DwItemAttribute(this.i, 'NoteLowForecastedGpm');
    NoteChangedGpm = new DwItemAttribute(this.i, 'NoteChangedGpm');
    AXIntegrationID = new DwItemAttribute(this.i, 'AXIntegrationID');
    TotalForecastRevenue = new DwItemAttribute(this.i, 'TotalForecastRevenue');
    TotalForecastCost = new DwItemAttribute(this.i, 'TotalForecastCost');
    LookUpKey = new DwItemAttribute(this.i, 'LookUpKey');
}

class EthosJobNumberForecastMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy = new DwItemRelationship('Ethos_User|Ethos_JobNumberForecast|CreatedBy', 'CreatedByEthosUser', 'CreatedByEthosUser');
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy = new DwItemRelationship('Ethos_User|Ethos_JobNumberForecast|ModifiedBy', 'ModifiedByEthosUser', 'ModifiedByEthosUser');
    };
export class EthosJobNumberMembershipMetaData implements DwItem2<EthosJobNumberMembershipEntity, EthosJobNumberMembershipMetaDataAttributes,EthosJobNumberMembershipMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2794;
        this.ItemDetail.itemName='Ethos_JobNumberMembership';
        this.ItemDetail.keyName='JobNumberMembershipId';
    }

    CreateEntity(): EthosJobNumberMembershipEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberMembershipQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberMembershipEntity, EthosJobNumberMembershipMetaDataAttributes,EthosJobNumberMembershipMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberMembershipMetaDataAttributes();
     Relations = new EthosJobNumberMembershipMetaDataRelations();

}


export type EthosJobNumberMembershipQueryBuilder = DwQueryBuilderGen<EthosJobNumberMembershipEntity, EthosJobNumberMembershipMetaDataAttributes,EthosJobNumberMembershipMetaDataRelations>


export class EthosJobNumberMembershipMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberMembership';
    // Attributes
    JobNumberMembershipId = new DwItemAttribute(this.i, 'JobNumberMembershipId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
}

class EthosJobNumberMembershipMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_User|Ethos_JobNumberMembership|UserId', 'EthosUser', 'EthosUser');
    };
export class EthosJobNumberPhaseMetaData implements DwItem2<EthosJobNumberPhaseEntity, EthosJobNumberPhaseMetaDataAttributes,EthosJobNumberPhaseMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2552;
        this.ItemDetail.itemName='Ethos_JobNumberPhase';
        this.ItemDetail.keyName='JobNumberPhaseId';
    }

    CreateEntity(): EthosJobNumberPhaseEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberPhaseQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberPhaseEntity, EthosJobNumberPhaseMetaDataAttributes,EthosJobNumberPhaseMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberPhaseMetaDataAttributes();
     Relations = new EthosJobNumberPhaseMetaDataRelations();

}


export type EthosJobNumberPhaseQueryBuilder = DwQueryBuilderGen<EthosJobNumberPhaseEntity, EthosJobNumberPhaseMetaDataAttributes,EthosJobNumberPhaseMetaDataRelations>


export class EthosJobNumberPhaseMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPhase';
    // Attributes
    JobNumberPhaseId = new DwItemAttribute(this.i, 'JobNumberPhaseId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    PhaseCode = new DwItemAttribute(this.i, 'PhaseCode');
    PhaseDescription = new DwItemAttribute(this.i, 'PhaseDescription');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsVisible = new DwItemAttribute(this.i, 'IsVisible');
    IsOnSite = new DwItemAttribute(this.i, 'IsOnSite');
    IsEstimate = new DwItemAttribute(this.i, 'IsEstimate');
    JobNumberPhaseStatusWs = new DwItemAttribute(this.i, 'JobNumberPhaseStatusWs');
    WorkflowStatusDisplay = new DwItemAttribute(this.i, 'WorkflowStatusDisplay');
    LookUpKey = new DwItemAttribute(this.i, 'LookUpKey');
}

class EthosJobNumberPhaseMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_JobNumberPhase|Ethos_WachterDepartment|JobNumberPhaseId', 'EthosWachterDepartment', 'EthosWachterDepartment');
    };
export class EthosJobNumberPriorityMetaData implements DwItem2<EthosJobNumberPriorityEntity, EthosJobNumberPriorityMetaDataAttributes,EthosJobNumberPriorityMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2792;
        this.ItemDetail.itemName='Ethos_JobNumberPriority';
        this.ItemDetail.keyName='JobNumberPriorityId';
    }

    CreateEntity(): EthosJobNumberPriorityEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosJobNumberPriorityQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosJobNumberPriorityEntity, EthosJobNumberPriorityMetaDataAttributes,EthosJobNumberPriorityMetaDataRelations>(query, this);
    }
     Attributes = new EthosJobNumberPriorityMetaDataAttributes();
     Relations = new EthosJobNumberPriorityMetaDataRelations();

}


export type EthosJobNumberPriorityQueryBuilder = DwQueryBuilderGen<EthosJobNumberPriorityEntity, EthosJobNumberPriorityMetaDataAttributes,EthosJobNumberPriorityMetaDataRelations>


export class EthosJobNumberPriorityMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPriority';
    // Attributes
    JobNumberPriorityId = new DwItemAttribute(this.i, 'JobNumberPriorityId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    PriorityName = new DwItemAttribute(this.i, 'PriorityName');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    ResponseTimeInHours = new DwItemAttribute(this.i, 'ResponseTimeInHours');
    StraightHourlyBillingRate = new DwItemAttribute(this.i, 'StraightHourlyBillingRate');
    OvertimeHourlyBillingRate = new DwItemAttribute(this.i, 'OvertimeHourlyBillingRate');
    HolidayHourlyBillingRate = new DwItemAttribute(this.i, 'HolidayHourlyBillingRate');
    TravelHourlyBillingRate = new DwItemAttribute(this.i, 'TravelHourlyBillingRate');
    MileageBillingRate = new DwItemAttribute(this.i, 'MileageBillingRate');
    MaxTravelInHours = new DwItemAttribute(this.i, 'MaxTravelInHours');
    CreatedDateTime = new DwItemAttribute(this.i, 'CreatedDateTime');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    ModifiedDateTime = new DwItemAttribute(this.i, 'ModifiedDateTime');
    ModifiedByUserId = new DwItemAttribute(this.i, 'ModifiedByUserId');
    TripCharge = new DwItemAttribute(this.i, 'TripCharge');
    ExpediteFee = new DwItemAttribute(this.i, 'ExpediteFee');
    IsEscalationEnabled = new DwItemAttribute(this.i, 'IsEscalationEnabled');
    SendPriorityNotification = new DwItemAttribute(this.i, 'SendPriorityNotification');
}

class EthosJobNumberPriorityMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumberPriority|CreatedByUserId', 'CreatedByEthosUser', 'CreatedByEthosUser');
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId', 'ModifiedByEthosUser', 'ModifiedByEthosUser');
    };
export class EthosServiceUserMetaData implements DwItem2<EthosServiceUserEntity, EthosServiceUserMetaDataAttributes,EthosServiceUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2676;
        this.ItemDetail.itemName='Ethos_ServiceUser';
        this.ItemDetail.keyName='EthosServiceUserId';
    }

    CreateEntity(): EthosServiceUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosServiceUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosServiceUserEntity, EthosServiceUserMetaDataAttributes,EthosServiceUserMetaDataRelations>(query, this);
    }
     Attributes = new EthosServiceUserMetaDataAttributes();
     Relations = new EthosServiceUserMetaDataRelations();

}


export type EthosServiceUserQueryBuilder = DwQueryBuilderGen<EthosServiceUserEntity, EthosServiceUserMetaDataAttributes,EthosServiceUserMetaDataRelations>


export class EthosServiceUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_ServiceUser';
    // Attributes
    EthosServiceUserId = new DwItemAttribute(this.i, 'EthosServiceUserId');
    EthosUserId = new DwItemAttribute(this.i, 'Ethos_UserId');
}

class EthosServiceUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId = new DwItemRelationship('Ethos_User|Ethos_ServiceUser|Ethos_UserId', 'EthosEthosUser', 'EthosEthosUser');
    };
export class EthosUserMetaData implements DwItem2<EthosUserEntity, EthosUserMetaDataAttributes,EthosUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2413;
        this.ItemDetail.itemName='Ethos_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): EthosUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosUserEntity, EthosUserMetaDataAttributes,EthosUserMetaDataRelations>(query, this);
    }
     Attributes = new EthosUserMetaDataAttributes();
     Relations = new EthosUserMetaDataRelations();

}


export type EthosUserQueryBuilder = DwQueryBuilderGen<EthosUserEntity, EthosUserMetaDataAttributes,EthosUserMetaDataRelations>


export class EthosUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserName = new DwItemAttribute(this.i, 'UserName');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    MiddleName = new DwItemAttribute(this.i, 'MiddleName');
    PreferredName = new DwItemAttribute(this.i, 'PreferredName');
    Suffix = new DwItemAttribute(this.i, 'Suffix');
    OfficePhone = new DwItemAttribute(this.i, 'OfficePhone');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    WachterJobTitleId = new DwItemAttribute(this.i, 'WachterJobTitleId');
    WachterJobTitle = new DwItemAttribute(this.i, 'WachterJobTitle');
    UserTypeCv = new DwItemAttribute(this.i, 'UserTypeCv');
    UserTypeDisplay = new DwItemAttribute(this.i, 'UserTypeDisplay');
    StaffingAgencyId = new DwItemAttribute(this.i, 'StaffingAgencyId');
    ResourceGroupCv = new DwItemAttribute(this.i, 'ResourceGroupCv');
    ResourceGroup = new DwItemAttribute(this.i, 'ResourceGroup');
    EmployeeGroupId = new DwItemAttribute(this.i, 'EmployeeGroupId');
    EmployeeGroupCode = new DwItemAttribute(this.i, 'EmployeeGroupCode');
    EmployeeGroupDescription = new DwItemAttribute(this.i, 'EmployeeGroupDescription');
    EmpHireDate = new DwItemAttribute(this.i, 'empHireDate');
    AddressLongitude = new DwItemAttribute(this.i, 'AddressLongitude');
    AddressLatitude = new DwItemAttribute(this.i, 'AddressLatitude');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    BirthMonth = new DwItemAttribute(this.i, 'BirthMonth');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    Email = new DwItemAttribute(this.i, 'Email');
    SupervisorUserId = new DwItemAttribute(this.i, 'SupervisorUserId');
    UserStatusWs = new DwItemAttribute(this.i, 'UserStatusWs');
    UserStatusMeaning = new DwItemAttribute(this.i, 'UserStatusMeaning');
    IsTerminated = new DwItemAttribute(this.i, 'IsTerminated');
    PictureAttachmentFileExtension = new DwItemAttribute(this.i, 'PictureAttachmentFileExtension');
    PictureAttachmentDisplay = new DwItemAttribute(this.i, 'PictureAttachmentDisplay');
    PictureAttachmentField = new DwItemAttribute(this.i, 'PictureAttachmentField');
    AdjustedStartDate = new DwItemAttribute(this.i, 'AdjustedStartDate');
    OfficeId = new DwItemAttribute(this.i, 'OfficeId');
    OfficeName = new DwItemAttribute(this.i, 'OfficeName');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    HasVehicle = new DwItemAttribute(this.i, 'HasVehicle');
    ShowUserOnMap = new DwItemAttribute(this.i, 'ShowUserOnMap');
    RowInsertDateTime = new DwItemAttribute(this.i, 'RowInsertDateTime');
    EmployeeType = new DwItemAttribute(this.i, 'EmployeeType');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    PictureAttachmentFileKey = new DwItemAttribute(this.i, 'PictureAttachmentFileKey');
    CustomerId = new DwItemAttribute(this.i, 'CustomerId');
    SubcontractorId = new DwItemAttribute(this.i, 'SubcontractorId');
    SpecialInstructions = new DwItemAttribute(this.i, 'SpecialInstructions');
    IsVaxxed = new DwItemAttribute(this.i, 'isVaxxed');
}

class EthosUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv = new DwItemRelationship('Ethos_User|Ethos_CodeValue|UserTypeCv', 'UserTypeCvEthosCodeValue', 'UserTypeCvEthosCodeValue');
            /** Relation: Ethos Code Value - Resource Group Cv */
            EthosCodeValueByResourceGroupCv = new DwItemRelationship('Ethos_CodeValue|Ethos_User|ResourceGroupCv', 'ResourceGroupCvEthosCodeValue', 'ResourceGroupCvEthosCodeValue');
            /** Relation: Job Number - User Id */
            EthosJobNumberByUserId = new DwItemRelationship('JobNumber->ProjectManager', 'UserIdEthosJobNumber', 'UserIdEthosJobNumber');
            /** Relation: Ethos User - Supervisor User - One */
            EthosUserBySupervisorUserId = new DwItemRelationship('Supervisor_User', 'SupervisorEthosUser', 'SupervisorEthosUser');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentId', 'EthosWachterDepartment', 'EthosWachterDepartment');
            /** Relation: Auction - Created By - Many */
            AuctionByCreatedByUserId = new DwItemRelationship('Ethos_User|Auction|CreatedByUserId', 'CreatedByAuction', 'CreatedByAuction');
            /** Relation: Auction - Modified By - Many */
            AuctionByModifiedByUserId = new DwItemRelationship('Ethos_User|Auction|ModifiedByUserId', 'ModifiedByAuction', 'ModifiedByAuction');
            /** Relation: Bid History - Created By - Many */
            BidHistoryByCreatedByUserId = new DwItemRelationship('Ethos_User|BidHistory|CreatedByUserId', 'CreatedByBidHistory', 'CreatedByBidHistory');
            /** Relation: Job Number - Project Mgr1 - Many */
            EthosJobNumberByProjectMgr1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|ProjectMgr1UserId', 'ProjectMgr1EthosJobNumber', 'ProjectMgr1EthosJobNumber');
            /** Relation: Job Number - Project Mgr2 - Many */
            EthosJobNumberByProjectMgr2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|ProjectMgr2UserId', 'ProjectMgr2EthosJobNumber', 'ProjectMgr2EthosJobNumber');
            /** Relation: Job Number - Asst Project Mgr - Many */
            EthosJobNumberByAsstProjectMgrUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId', 'AsstProjectMgrEthosJobNumber', 'AsstProjectMgrEthosJobNumber');
            /** Relation: Job Number - Senior Mgr - Many */
            EthosJobNumberBySeniorMgrUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|SeniorMgrUserId', 'SeniorMgrEthosJobNumber', 'SeniorMgrEthosJobNumber');
            /** Relation: Job Number - Lead Tech1 - Many */
            EthosJobNumberByLeadTech1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|LeadTech1UserId', 'LeadTech1EthosJobNumber', 'LeadTech1EthosJobNumber');
            /** Relation: Job Number - Lead Tech2 - Many */
            EthosJobNumberByLeadTech2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|LeadTech2UserId', 'LeadTech2EthosJobNumber', 'LeadTech2EthosJobNumber');
            /** Relation: Job Number - Invoice Approval1 - Many */
            EthosJobNumberByInvoiceApproval1UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId', 'InvoiceApproval1EthosJobNumber', 'InvoiceApproval1EthosJobNumber');
            /** Relation: Job Number - Invoice Approval2 - Many */
            EthosJobNumberByInvoiceApproval2UserId = new DwItemRelationship('Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId', 'InvoiceApproval2EthosJobNumber', 'InvoiceApproval2EthosJobNumber');
            /** Relation: Job Number Forecast - Created By - Many */
            EthosJobNumberForecastByCreatedBy = new DwItemRelationship('Ethos_User|Ethos_JobNumberForecast|CreatedBy', 'CreatedByEthosJobNumberForecast', 'CreatedByEthosJobNumberForecast');
            /** Relation: Job Number Forecast - Modified By - Many */
            EthosJobNumberForecastByModifiedBy = new DwItemRelationship('Ethos_User|Ethos_JobNumberForecast|ModifiedBy', 'ModifiedByEthosJobNumberForecast', 'ModifiedByEthosJobNumberForecast');
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership = new DwItemRelationship('Ethos_User|Ethos_JobNumberMembership|UserId', 'EthosJobNumberMembership', 'EthosJobNumberMembership');
            /** Relation: Ethos Job Number Priority - Created By - Many */
            EthosJobNumberPriorityByCreatedByUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumberPriority|CreatedByUserId', 'CreatedByEthosJobNumberPriority', 'CreatedByEthosJobNumberPriority');
            /** Relation: Ethos Job Number Priority - Modified By - Many */
            EthosJobNumberPriorityByModifiedByUserId = new DwItemRelationship('Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId', 'ModifiedByEthosJobNumberPriority', 'ModifiedByEthosJobNumberPriority');
            /** Relation: Ethos Service User - Many */
            EthosServiceUserByEthosUserId = new DwItemRelationship('Ethos_User|Ethos_ServiceUser|Ethos_UserId', 'EthosEthosServiceUser', 'EthosEthosServiceUser');
            /** Relation: Ethos User Diff - Many */
            EthosUserDiffByEthosUserId = new DwItemRelationship('Ethos_User|Ethos_UserDiff|Ethos_UserId', 'EthosEthosUserDiff', 'EthosEthosUserDiff');
            /** Relation: User Skill */
            EthosUserSkill = new DwItemRelationship('Ethos_User|Ethos_UserSkill|UserId', 'EthosUserSkill', 'EthosUserSkill');
            /** Relation: Wachter Department - Department Director - Many */
            EthosWachterDepartmentByDepartmentDirectorUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId', 'DepartmentDirectorEthosWachterDepartment', 'DepartmentDirectorEthosWachterDepartment');
            /** Relation: Wachter Department - Department Manager - Many */
            EthosWachterDepartmentByDepartmentManagerUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId', 'DepartmentManagerEthosWachterDepartment', 'DepartmentManagerEthosWachterDepartment');
            /** Relation: Wachter Department - Department Asst Manager - Many */
            EthosWachterDepartmentByDepartmentAsstManagerUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId', 'DepartmentAsstManagerEthosWachterDepartment', 'DepartmentAsstManagerEthosWachterDepartment');
            /** Relation: Maintenance - Created By - Many */
            MaintenanceByCreatedByUserId = new DwItemRelationship('Ethos_User|Maintenance|CreatedByUserId', 'CreatedByMaintenance', 'CreatedByMaintenance');
            /** Relation: Maintenance - Modified By - Many */
            MaintenanceByModifiedByUserId = new DwItemRelationship('Ethos_User|Maintenance|ModifiedByUserId', 'ModifiedByMaintenance', 'ModifiedByMaintenance');
            /** Relation: Maintenance - Driver - Many */
            MaintenanceByDriverUserId = new DwItemRelationship('Ethos_User|Maintenance|DriverUserId', 'DriverMaintenance', 'DriverMaintenance');
            /** Relation: Paf History - Created By - Many */
            PafHistoryByCreatedByUserId = new DwItemRelationship('Ethos_User|PafHistory|CreatedByUserId', 'CreatedByPafHistory', 'CreatedByPafHistory');
            /** Relation: Ro Ethos User */
            RoEthosUser = new DwItemRelationship('Ethos_User|roEthos_User|UserId', 'RoEthosUser', 'RoEthosUser');
            /** Relation: Ro Ethos User - Supervisor - Many */
            RoEthosUserBySupervisorUserId = new DwItemRelationship('Ethos_User|roEthos_User|SupervisorUserId', 'SupervisorRoEthosUser', 'SupervisorRoEthosUser');
            /** Relation: Vehicle - Driver - Many */
            FleetVehicleByDriverUserId = new DwItemRelationship('Ethos_User|fleet_Vehicle|DriverUserId', 'DriverFleetVehicle', 'DriverFleetVehicle');
            /** Relation: Vehicle - Created By - Many */
            FleetVehicleByCreatedByUserId = new DwItemRelationship('Ethos_User|fleet_Vehicle|CreatedByUserId', 'CreatedByFleetVehicle', 'CreatedByFleetVehicle');
            /** Relation: Vehicle - Modified By - Many */
            FleetVehicleByModifiedByUserId = new DwItemRelationship('Ethos_User|fleet_Vehicle|ModifiedByUserId', 'ModifiedByFleetVehicle', 'ModifiedByFleetVehicle');
            /** Relation: Vehicle - Additional Driver - Many */
            FleetVehicleByAdditionalDriverUserId = new DwItemRelationship('Ethos_User|fleet_Vehicle|AdditionalDriverUserId', 'AdditionalDriverFleetVehicle', 'AdditionalDriverFleetVehicle');
    };
export class EthosUserDiffMetaData implements DwItem2<EthosUserDiffEntity, EthosUserDiffMetaDataAttributes,EthosUserDiffMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2572;
        this.ItemDetail.itemName='Ethos_UserDiff';
        this.ItemDetail.keyName='Ethos_UserDiffId';
    }

    CreateEntity(): EthosUserDiffEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosUserDiffQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosUserDiffEntity, EthosUserDiffMetaDataAttributes,EthosUserDiffMetaDataRelations>(query, this);
    }
     Attributes = new EthosUserDiffMetaDataAttributes();
     Relations = new EthosUserDiffMetaDataRelations();

}


export type EthosUserDiffQueryBuilder = DwQueryBuilderGen<EthosUserDiffEntity, EthosUserDiffMetaDataAttributes,EthosUserDiffMetaDataRelations>


export class EthosUserDiffMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff';
    // Attributes
    EthosUserDiffId = new DwItemAttribute(this.i, 'Ethos_UserDiffId');
    EthosUserId = new DwItemAttribute(this.i, 'Ethos_UserId');
    FieldName = new DwItemAttribute(this.i, 'FieldName');
    OldValue = new DwItemAttribute(this.i, 'OldValue');
    NewValue = new DwItemAttribute(this.i, 'NewValue');
    ChangedDateTime = new DwItemAttribute(this.i, 'ChangedDateTime');
}

class EthosUserDiffMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId = new DwItemRelationship('Ethos_User|Ethos_UserDiff|Ethos_UserId', 'EthosEthosUser', 'EthosEthosUser');
    };
export class EthosUserSkillMetaData implements DwItem2<EthosUserSkillEntity, EthosUserSkillMetaDataAttributes,EthosUserSkillMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2410;
        this.ItemDetail.itemName='Ethos_UserSkill';
        this.ItemDetail.keyName='UserSkillId';
    }

    CreateEntity(): EthosUserSkillEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosUserSkillQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosUserSkillEntity, EthosUserSkillMetaDataAttributes,EthosUserSkillMetaDataRelations>(query, this);
    }
     Attributes = new EthosUserSkillMetaDataAttributes();
     Relations = new EthosUserSkillMetaDataRelations();

}


export type EthosUserSkillQueryBuilder = DwQueryBuilderGen<EthosUserSkillEntity, EthosUserSkillMetaDataAttributes,EthosUserSkillMetaDataRelations>


export class EthosUserSkillMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill';
    // Attributes
    UserSkillId = new DwItemAttribute(this.i, 'UserSkillId');
    UserId = new DwItemAttribute(this.i, 'UserId');
    SkillCv = new DwItemAttribute(this.i, 'SkillCv');
    Meaning = new DwItemAttribute(this.i, 'Meaning');
    Display = new DwItemAttribute(this.i, 'Display');
}

class EthosUserSkillMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos Code Value - Skill */
            EthosCodeValueBySkillCv = new DwItemRelationship('Ethos_CodeValue|Ethos_UserSkill|SkillCv', 'SkillCvEthosCodeValue', 'SkillCvEthosCodeValue');
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_User|Ethos_UserSkill|UserId', 'EthosUser', 'EthosUser');
    };
export class EthosWachterDepartmentMetaData implements DwItem2<EthosWachterDepartmentEntity, EthosWachterDepartmentMetaDataAttributes,EthosWachterDepartmentMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2388;
        this.ItemDetail.itemName='Ethos_WachterDepartment';
        this.ItemDetail.keyName='WachterDepartmentId';
    }

    CreateEntity(): EthosWachterDepartmentEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): EthosWachterDepartmentQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<EthosWachterDepartmentEntity, EthosWachterDepartmentMetaDataAttributes,EthosWachterDepartmentMetaDataRelations>(query, this);
    }
     Attributes = new EthosWachterDepartmentMetaDataAttributes();
     Relations = new EthosWachterDepartmentMetaDataRelations();

}


export type EthosWachterDepartmentQueryBuilder = DwQueryBuilderGen<EthosWachterDepartmentEntity, EthosWachterDepartmentMetaDataAttributes,EthosWachterDepartmentMetaDataRelations>


export class EthosWachterDepartmentMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterDepartment';
    // Attributes
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    DepartmentTypeCv = new DwItemAttribute(this.i, 'DepartmentTypeCv');
    DepartmentTypeMeaning = new DwItemAttribute(this.i, 'DepartmentTypeMeaning');
    WachterDivisionId = new DwItemAttribute(this.i, 'WachterDivisionId');
    DivisionName = new DwItemAttribute(this.i, 'DivisionName');
    DivisionShortName = new DwItemAttribute(this.i, 'DivisionShortName');
    DepartmentName = new DwItemAttribute(this.i, 'DepartmentName');
    DepartmentShortName = new DwItemAttribute(this.i, 'DepartmentShortName');
    DepartmentDirectorUserId = new DwItemAttribute(this.i, 'DepartmentDirectorUserId');
    IsDeleted = new DwItemAttribute(this.i, 'IsDeleted');
    DepartmentManagerUserId = new DwItemAttribute(this.i, 'DepartmentManagerUserId');
    DepartmentAsstManagerUserId = new DwItemAttribute(this.i, 'DepartmentAsstManagerUserId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    AxIntegrationId = new DwItemAttribute(this.i, 'AxIntegrationId');
    JobNumberPhaseId = new DwItemAttribute(this.i, 'JobNumberPhaseId');
    RowInsertDateTime = new DwItemAttribute(this.i, 'RowInsertDateTime');
}

class EthosWachterDepartmentMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos Code Value - Department Type */
            EthosCodeValueByDepartmentTypeCv = new DwItemRelationship('Ethos_CodeValue|Ethos_WachterDepartment|DepartmentTypeCv', 'DepartmentTypeCvEthosCodeValue', 'DepartmentTypeCvEthosCodeValue');
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Ethos_WachterDepartment|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase = new DwItemRelationship('Ethos_JobNumberPhase|Ethos_WachterDepartment|JobNumberPhaseId', 'EthosJobNumberPhase', 'EthosJobNumberPhase');
            /** Relation: Ethos User - Department Director User */
            EthosUserByDepartmentDirectorUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentDirectorUserId', 'DepartmentDirectorEthosUser', 'DepartmentDirectorEthosUser');
            /** Relation: Ethos User - Department Manager User */
            EthosUserByDepartmentManagerUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentManagerUserId', 'DepartmentManagerEthosUser', 'DepartmentManagerEthosUser');
            /** Relation: Ethos User - Department Asst Manager User */
            EthosUserByDepartmentAsstManagerUserId = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentAsstManagerUserId', 'DepartmentAsstManagerEthosUser', 'DepartmentAsstManagerEthosUser');
            /** Relation: Department Map */
            DepartmentMap = new DwItemRelationship('Ethos_WachterDepartment|DepartmentMap|WachterDepartmentId', 'DepartmentMap', 'DepartmentMap');
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_User|Ethos_WachterDepartment|DepartmentId', 'EthosUser', 'EthosUser');
            /** Relation: Ro Ethos User */
            RoEthosUser = new DwItemRelationship('Ethos_WachterDepartment|roEthos_User|WachterDepartmentId', 'RoEthosUser', 'RoEthosUser');
            /** Relation: Vehicle */
            FleetVehicle = new DwItemRelationship('Ethos_WachterDepartment|fleet_Vehicle|WachterDepartmentId', 'FleetVehicle', 'FleetVehicle');
    };
export class MaintenanceMetaData implements DwItem2<MaintenanceEntity, MaintenanceMetaDataAttributes,MaintenanceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3432;
        this.ItemDetail.itemName='Maintenance';
        this.ItemDetail.keyName='MaintenanceId';
    }

    CreateEntity(): MaintenanceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MaintenanceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MaintenanceEntity, MaintenanceMetaDataAttributes,MaintenanceMetaDataRelations>(query, this);
    }
     Attributes = new MaintenanceMetaDataAttributes();
     Relations = new MaintenanceMetaDataRelations();

}


export type MaintenanceQueryBuilder = DwQueryBuilderGen<MaintenanceEntity, MaintenanceMetaDataAttributes,MaintenanceMetaDataRelations>


export class MaintenanceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Maintenance';
    // Attributes
    MaintenanceId = new DwItemAttribute(this.i, 'MaintenanceId');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    ModifiedByUserId = new DwItemAttribute(this.i, 'ModifiedByUserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    SharepointId = new DwItemAttribute(this.i, 'SharepointId');
    VehicleId = new DwItemAttribute(this.i, 'VehicleId');
    Date = new DwItemAttribute(this.i, 'Date');
    DriverUserId = new DwItemAttribute(this.i, 'DriverUserId');
    RawDriverName = new DwItemAttribute(this.i, 'RawDriverName');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    Odometer = new DwItemAttribute(this.i, 'Odometer');
    Cost = new DwItemAttribute(this.i, 'Cost');
    PONumber = new DwItemAttribute(this.i, 'PONumber');
    ServiceProvider = new DwItemAttribute(this.i, 'ServiceProvider');
    ServiceType = new DwItemAttribute(this.i, 'ServiceType');
    CurrentLicensePlate = new DwItemAttribute(this.i, 'CurrentLicensePlate');
    NoteParentId = new DwItemAttribute(this.i, 'NoteParentId');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    Phase = new DwItemAttribute(this.i, 'Phase');
    IsEmployee = new DwItemAttribute(this.i, 'IsEmployee');
}

class MaintenanceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|Maintenance|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId = new DwItemRelationship('Ethos_User|Maintenance|CreatedByUserId', 'CreatedByEthosUser', 'CreatedByEthosUser');
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId = new DwItemRelationship('Ethos_User|Maintenance|ModifiedByUserId', 'ModifiedByEthosUser', 'ModifiedByEthosUser');
            /** Relation: Ethos User - Driver User */
            EthosUserByDriverUserId = new DwItemRelationship('Ethos_User|Maintenance|DriverUserId', 'DriverEthosUser', 'DriverEthosUser');
            /** Relation: Vehicle */
            FleetVehicle = new DwItemRelationship('fleet_Vehicle|Maintenance|VehicleId', 'FleetVehicle', 'FleetVehicle');
            /** Relation: Maintenance Service */
            MaintenanceService = new DwItemRelationship('Maintenance|MaintenanceService|MaintenanceId', 'MaintenanceService', 'MaintenanceService');
            /** Relation: Ro Maintenance */
            RoMaintenance = new DwItemRelationship('roMaintenance|Maintenance|MaintenanceId', 'RoMaintenance', 'RoMaintenance');
    };
export class MaintenanceServiceMetaData implements DwItem2<MaintenanceServiceEntity, MaintenanceServiceMetaDataAttributes,MaintenanceServiceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3441;
        this.ItemDetail.itemName='MaintenanceService';
        this.ItemDetail.keyName='MaintenanceServiceId';
    }

    CreateEntity(): MaintenanceServiceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): MaintenanceServiceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<MaintenanceServiceEntity, MaintenanceServiceMetaDataAttributes,MaintenanceServiceMetaDataRelations>(query, this);
    }
     Attributes = new MaintenanceServiceMetaDataAttributes();
     Relations = new MaintenanceServiceMetaDataRelations();

}


export type MaintenanceServiceQueryBuilder = DwQueryBuilderGen<MaintenanceServiceEntity, MaintenanceServiceMetaDataAttributes,MaintenanceServiceMetaDataRelations>


export class MaintenanceServiceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'MaintenanceService';
    // Attributes
    MaintenanceServiceId = new DwItemAttribute(this.i, 'MaintenanceServiceId');
    MaintenanceId = new DwItemAttribute(this.i, 'MaintenanceId');
    ServiceTypeId = new DwItemAttribute(this.i, 'ServiceTypeId');
}

class MaintenanceServiceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Maintenance */
            Maintenance = new DwItemRelationship('Maintenance|MaintenanceService|MaintenanceId', 'Maintenance', 'Maintenance');
            /** Relation: Service Type */
            ServiceType = new DwItemRelationship('ServiceType|MaintenanceService|ServiceTypeId', 'ServiceType', 'ServiceType');
    };
export class PafHistoryMetaData implements DwItem2<PafHistoryEntity, PafHistoryMetaDataAttributes,PafHistoryMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3436;
        this.ItemDetail.itemName='PafHistory';
        this.ItemDetail.keyName='PafHistoryId';
    }

    CreateEntity(): PafHistoryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): PafHistoryQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<PafHistoryEntity, PafHistoryMetaDataAttributes,PafHistoryMetaDataRelations>(query, this);
    }
     Attributes = new PafHistoryMetaDataAttributes();
     Relations = new PafHistoryMetaDataRelations();

}


export type PafHistoryQueryBuilder = DwQueryBuilderGen<PafHistoryEntity, PafHistoryMetaDataAttributes,PafHistoryMetaDataRelations>


export class PafHistoryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'PafHistory';
    // Attributes
    PafHistoryId = new DwItemAttribute(this.i, 'PafHistoryId');
    VehicleId = new DwItemAttribute(this.i, 'VehicleId');
    Note = new DwItemAttribute(this.i, 'Note');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
}

class PafHistoryMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId = new DwItemRelationship('Ethos_User|PafHistory|CreatedByUserId', 'CreatedByEthosUser', 'CreatedByEthosUser');
            /** Relation: Vehicle */
            FleetVehicle = new DwItemRelationship('fleet_Vehicle|PafHistory|VehicleId', 'FleetVehicle', 'FleetVehicle');
    };
export class RoAuctionMetaData implements DwItem2<RoAuctionEntity, RoAuctionMetaDataAttributes,RoAuctionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3439;
        this.ItemDetail.itemName='roAuction';
        this.ItemDetail.keyName='AuctionId';
    }

    CreateEntity(): RoAuctionEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoAuctionQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoAuctionEntity, RoAuctionMetaDataAttributes,RoAuctionMetaDataRelations>(query, this);
    }
     Attributes = new RoAuctionMetaDataAttributes();
     Relations = new RoAuctionMetaDataRelations();

}


export type RoAuctionQueryBuilder = DwQueryBuilderGen<RoAuctionEntity, RoAuctionMetaDataAttributes,RoAuctionMetaDataRelations>


export class RoAuctionMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roAuction';
    // Attributes
    AuctionId = new DwItemAttribute(this.i, 'AuctionId');
    CurrentBid = new DwItemAttribute(this.i, 'CurrentBid');
    FinalBid = new DwItemAttribute(this.i, 'FinalBid');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    StatusCv = new DwItemAttribute(this.i, 'StatusCv');
    AppUserId = new DwItemAttribute(this.i, 'AppUserId');
}

class RoAuctionMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Auction */
            Auction = new DwItemRelationship('roAuction|Auction|AuctionId', 'Auction', 'Auction');
    };
export class RoEthosUserMetaData implements DwItem2<RoEthosUserEntity, RoEthosUserMetaDataAttributes,RoEthosUserMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2419;
        this.ItemDetail.itemName='roEthos_User';
        this.ItemDetail.keyName='UserId';
    }

    CreateEntity(): RoEthosUserEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoEthosUserQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoEthosUserEntity, RoEthosUserMetaDataAttributes,RoEthosUserMetaDataRelations>(query, this);
    }
     Attributes = new RoEthosUserMetaDataAttributes();
     Relations = new RoEthosUserMetaDataRelations();

}


export type RoEthosUserQueryBuilder = DwQueryBuilderGen<RoEthosUserEntity, RoEthosUserMetaDataAttributes,RoEthosUserMetaDataRelations>


export class RoEthosUserMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    UserName = new DwItemAttribute(this.i, 'UserName');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    MiddleName = new DwItemAttribute(this.i, 'MiddleName');
    PreferredName = new DwItemAttribute(this.i, 'PreferredName');
    Suffix = new DwItemAttribute(this.i, 'Suffix');
    OfficePhone = new DwItemAttribute(this.i, 'OfficePhone');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    WachterJobTitleId = new DwItemAttribute(this.i, 'WachterJobTitleId');
    WachterJobTitle = new DwItemAttribute(this.i, 'WachterJobTitle');
    UserTypeCv = new DwItemAttribute(this.i, 'UserTypeCv');
    UserTypeDisplay = new DwItemAttribute(this.i, 'UserTypeDisplay');
    StaffingAgencyId = new DwItemAttribute(this.i, 'StaffingAgencyId');
    ResourceGroupCv = new DwItemAttribute(this.i, 'ResourceGroupCv');
    ResourceGroup = new DwItemAttribute(this.i, 'ResourceGroup');
    EmployeeGroupId = new DwItemAttribute(this.i, 'EmployeeGroupId');
    EmployeeGroupCode = new DwItemAttribute(this.i, 'EmployeeGroupCode');
    EmployeeGroupDescription = new DwItemAttribute(this.i, 'EmployeeGroupDescription');
    EmpHireDate = new DwItemAttribute(this.i, 'empHireDate');
    AddressLongitude = new DwItemAttribute(this.i, 'AddressLongitude');
    AddressLatitude = new DwItemAttribute(this.i, 'AddressLatitude');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    BirthMonth = new DwItemAttribute(this.i, 'BirthMonth');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    Email = new DwItemAttribute(this.i, 'Email');
    SupervisorUserId = new DwItemAttribute(this.i, 'SupervisorUserId');
    UserStatusWs = new DwItemAttribute(this.i, 'UserStatusWs');
    UserStatusMeaning = new DwItemAttribute(this.i, 'UserStatusMeaning');
    IsTerminated = new DwItemAttribute(this.i, 'IsTerminated');
    PictureAttachmentFileExtension = new DwItemAttribute(this.i, 'PictureAttachmentFileExtension');
    PictureAttachmentDisplay = new DwItemAttribute(this.i, 'PictureAttachmentDisplay');
    PictureAttachmentField = new DwItemAttribute(this.i, 'PictureAttachmentField');
    AdjustedStartDate = new DwItemAttribute(this.i, 'AdjustedStartDate');
    OfficeId = new DwItemAttribute(this.i, 'OfficeId');
    OfficeName = new DwItemAttribute(this.i, 'OfficeName');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    HasVehicle = new DwItemAttribute(this.i, 'HasVehicle');
    ShowUserOnMap = new DwItemAttribute(this.i, 'ShowUserOnMap');
    RowInsertDateTime = new DwItemAttribute(this.i, 'RowInsertDateTime');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    TeamShortName = new DwItemAttribute(this.i, 'TeamShortName');
    TeamNickName = new DwItemAttribute(this.i, 'TeamNickName');
    DepartmentName = new DwItemAttribute(this.i, 'DepartmentName');
    DepartmentShortName = new DwItemAttribute(this.i, 'DepartmentShortName');
    WachterDivisionId = new DwItemAttribute(this.i, 'WachterDivisionId');
    DivisionName = new DwItemAttribute(this.i, 'DivisionName');
    DivisionShortName = new DwItemAttribute(this.i, 'DivisionShortName');
    NameLastFirst = new DwItemAttribute(this.i, 'NameLastFirst');
    NameLastPrefered = new DwItemAttribute(this.i, 'NameLastPrefered');
    NameLastFirstPrefered = new DwItemAttribute(this.i, 'NameLastFirstPrefered');
    NameFirstLast = new DwItemAttribute(this.i, 'NameFirstLast');
    NamePreferedLast = new DwItemAttribute(this.i, 'NamePreferedLast');
    NameFirstPreferedLast = new DwItemAttribute(this.i, 'NameFirstPreferedLast');
    NameFirstMiddleLast = new DwItemAttribute(this.i, 'NameFirstMiddleLast');
    NamePreferedMidInitialLast = new DwItemAttribute(this.i, 'NamePreferedMidInitialLast');
    NameLastFirstPreferedStatus = new DwItemAttribute(this.i, 'NameLastFirstPreferedStatus');
    EmployeeType = new DwItemAttribute(this.i, 'EmployeeType');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    PictureAttachmentFileKey = new DwItemAttribute(this.i, 'PictureAttachmentFileKey');
    NameLastFirstPreferedType = new DwItemAttribute(this.i, 'NameLastFirstPreferedType');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    SpecialInstructions = new DwItemAttribute(this.i, 'SpecialInstructions');
    BirthMonthDate = new DwItemAttribute(this.i, 'BirthMonthDate');
    TerritoryId = new DwItemAttribute(this.i, 'TerritoryId');
    TerritoryName = new DwItemAttribute(this.i, 'TerritoryName');
    Company = new DwItemAttribute(this.i, 'Company');
    LicenseCount = new DwItemAttribute(this.i, 'LicenseCount');
    AXId = new DwItemAttribute(this.i, 'AXId');
    YrsService = new DwItemAttribute(this.i, 'YrsService');
    StaffingAgencyName = new DwItemAttribute(this.i, 'StaffingAgencyName');
}

class RoEthosUserMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Ethos Code Value - Resource Group Cv */
            EthosCodeValueByResourceGroupCv = new DwItemRelationship('Ethos_CodeValue|roEthos_User|ResourceGroupCv', 'ResourceGroupCvEthosCodeValue', 'ResourceGroupCvEthosCodeValue');
            /** Relation: Ethos Code Value - User Type */
            EthosCodeValueByUserTypeCv = new DwItemRelationship('Ethos_CodeValue|roEthos_User|UserTypeCv', 'UserTypeCvEthosCodeValue', 'UserTypeCvEthosCodeValue');
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId = new DwItemRelationship('roEthos_User|roEthos_User|SupervisorId', 'SupervisorRoEthosUser', 'SupervisorRoEthosUser');
            /** Relation: Ethos User */
            EthosUser = new DwItemRelationship('Ethos_User|roEthos_User|UserId', 'EthosUser', 'EthosUser');
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId = new DwItemRelationship('Ethos_User|roEthos_User|SupervisorUserId', 'SupervisorEthosUser', 'SupervisorEthosUser');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_WachterDepartment|roEthos_User|WachterDepartmentId', 'EthosWachterDepartment', 'EthosWachterDepartment');
    };
export class RoEthosUserOriginalMetaData implements DwItem2<RoEthosUserOriginalEntity, RoEthosUserOriginalMetaDataAttributes,RoEthosUserOriginalMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2661;
        this.ItemDetail.itemName='roEthos_UserOriginal';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoEthosUserOriginalEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoEthosUserOriginalQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoEthosUserOriginalEntity, RoEthosUserOriginalMetaDataAttributes,RoEthosUserOriginalMetaDataRelations>(query, this);
    }
     Attributes = new RoEthosUserOriginalMetaDataAttributes();
     Relations = new RoEthosUserOriginalMetaDataRelations();

}


export type RoEthosUserOriginalQueryBuilder = DwQueryBuilderGen<RoEthosUserOriginalEntity, RoEthosUserOriginalMetaDataAttributes,RoEthosUserOriginalMetaDataRelations>


export class RoEthosUserOriginalMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal';
    // Attributes
    UserId = new DwItemAttribute(this.i, 'UserId');
    AXId = new DwItemAttribute(this.i, 'AXId');
    UserName = new DwItemAttribute(this.i, 'UserName');
    FirstName = new DwItemAttribute(this.i, 'FirstName');
    LastName = new DwItemAttribute(this.i, 'LastName');
    MiddleName = new DwItemAttribute(this.i, 'MiddleName');
    PreferredName = new DwItemAttribute(this.i, 'PreferredName');
    Suffix = new DwItemAttribute(this.i, 'Suffix');
    OfficePhone = new DwItemAttribute(this.i, 'OfficePhone');
    MobilePhone = new DwItemAttribute(this.i, 'MobilePhone');
    WachterJobTitleId = new DwItemAttribute(this.i, 'WachterJobTitleId');
    WachterJobTitle = new DwItemAttribute(this.i, 'WachterJobTitle');
    UserTypeCv = new DwItemAttribute(this.i, 'UserTypeCv');
    UserTypeDisplay = new DwItemAttribute(this.i, 'UserTypeDisplay');
    EmployeeType = new DwItemAttribute(this.i, 'EmployeeType');
    StaffingAgencyId = new DwItemAttribute(this.i, 'StaffingAgencyId');
    ResourceGroupCv = new DwItemAttribute(this.i, 'ResourceGroupCv');
    ResourceGroup = new DwItemAttribute(this.i, 'ResourceGroup');
    EmployeeGroupId = new DwItemAttribute(this.i, 'EmployeeGroupId');
    EmployeeGroupCode = new DwItemAttribute(this.i, 'EmployeeGroupCode');
    EmployeeGroupDescription = new DwItemAttribute(this.i, 'EmployeeGroupDescription');
    EmpHireDate = new DwItemAttribute(this.i, 'empHireDate');
    AddressLongitude = new DwItemAttribute(this.i, 'AddressLongitude');
    AddressLatitude = new DwItemAttribute(this.i, 'AddressLatitude');
    WachterTeamId = new DwItemAttribute(this.i, 'WachterTeamId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    BirthMonth = new DwItemAttribute(this.i, 'BirthMonth');
    BirthDate = new DwItemAttribute(this.i, 'BirthDate');
    BirthMonthDate = new DwItemAttribute(this.i, 'BirthMonthDate');
    Email = new DwItemAttribute(this.i, 'Email');
    SupervisorUserId = new DwItemAttribute(this.i, 'SupervisorUserId');
    UserStatusWs = new DwItemAttribute(this.i, 'UserStatusWs');
    UserStatusMeaning = new DwItemAttribute(this.i, 'UserStatusMeaning');
    IsActive = new DwItemAttribute(this.i, 'IsActive');
    IsTerminated = new DwItemAttribute(this.i, 'IsTerminated');
    PictureAttachmentFileExtension = new DwItemAttribute(this.i, 'PictureAttachmentFileExtension');
    PictureAttachmentDisplay = new DwItemAttribute(this.i, 'PictureAttachmentDisplay');
    PictureAttachmentFileKey = new DwItemAttribute(this.i, 'PictureAttachmentFileKey');
    PictureAttachmentField = new DwItemAttribute(this.i, 'PictureAttachmentField');
    AdjustedStartDate = new DwItemAttribute(this.i, 'AdjustedStartDate');
    OfficeId = new DwItemAttribute(this.i, 'OfficeId');
    OfficeName = new DwItemAttribute(this.i, 'OfficeName');
    StreetAddress1 = new DwItemAttribute(this.i, 'StreetAddress1');
    StreetAddress2 = new DwItemAttribute(this.i, 'StreetAddress2');
    City = new DwItemAttribute(this.i, 'City');
    StateProvinceId = new DwItemAttribute(this.i, 'StateProvinceId');
    StateProvinceShortName = new DwItemAttribute(this.i, 'StateProvinceShortName');
    TerritoryId = new DwItemAttribute(this.i, 'TerritoryId');
    TerritoryName = new DwItemAttribute(this.i, 'TerritoryName');
    PostalCode = new DwItemAttribute(this.i, 'PostalCode');
    HasVehicle = new DwItemAttribute(this.i, 'HasVehicle');
    ShowUserOnMap = new DwItemAttribute(this.i, 'ShowUserOnMap');
    SpecialInstructions = new DwItemAttribute(this.i, 'SpecialInstructions');
    RowInsertDateTime = new DwItemAttribute(this.i, 'RowInsertDateTime');
    TeamName = new DwItemAttribute(this.i, 'TeamName');
    TeamShortName = new DwItemAttribute(this.i, 'TeamShortName');
    TeamNickName = new DwItemAttribute(this.i, 'TeamNickName');
    DepartmentName = new DwItemAttribute(this.i, 'DepartmentName');
    DepartmentShortName = new DwItemAttribute(this.i, 'DepartmentShortName');
    WachterDivisionId = new DwItemAttribute(this.i, 'WachterDivisionId');
    DivisionName = new DwItemAttribute(this.i, 'DivisionName');
    DivisionShortName = new DwItemAttribute(this.i, 'DivisionShortName');
    Company = new DwItemAttribute(this.i, 'Company');
    LicenseCount = new DwItemAttribute(this.i, 'LicenseCount');
    NameLastFirst = new DwItemAttribute(this.i, 'NameLastFirst');
    NameLastPrefered = new DwItemAttribute(this.i, 'NameLastPrefered');
    NameLastFirstPrefered = new DwItemAttribute(this.i, 'NameLastFirstPrefered');
    NameFirstLast = new DwItemAttribute(this.i, 'NameFirstLast');
    NamePreferedLast = new DwItemAttribute(this.i, 'NamePreferedLast');
    NameFirstPreferedLast = new DwItemAttribute(this.i, 'NameFirstPreferedLast');
    NameFirstMiddleLast = new DwItemAttribute(this.i, 'NameFirstMiddleLast');
    NamePreferedMidInitialLast = new DwItemAttribute(this.i, 'NamePreferedMidInitialLast');
    NameLastFirstPreferedStatus = new DwItemAttribute(this.i, 'NameLastFirstPreferedStatus');
    NameLastFirstPreferedType = new DwItemAttribute(this.i, 'NameLastFirstPreferedType');
}

class RoEthosUserOriginalMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoMaintenanceMetaData implements DwItem2<RoMaintenanceEntity, RoMaintenanceMetaDataAttributes,RoMaintenanceMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3440;
        this.ItemDetail.itemName='roMaintenance';
        this.ItemDetail.keyName='MaintenanceId';
    }

    CreateEntity(): RoMaintenanceEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoMaintenanceQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoMaintenanceEntity, RoMaintenanceMetaDataAttributes,RoMaintenanceMetaDataRelations>(query, this);
    }
     Attributes = new RoMaintenanceMetaDataAttributes();
     Relations = new RoMaintenanceMetaDataRelations();

}


export type RoMaintenanceQueryBuilder = DwQueryBuilderGen<RoMaintenanceEntity, RoMaintenanceMetaDataAttributes,RoMaintenanceMetaDataRelations>


export class RoMaintenanceMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roMaintenance';
    // Attributes
    MaintenanceId = new DwItemAttribute(this.i, 'MaintenanceId');
    SortableUnitId = new DwItemAttribute(this.i, 'SortableUnitId');
    DriverName = new DwItemAttribute(this.i, 'DriverName');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    VIN = new DwItemAttribute(this.i, 'VIN');
    VehicleId = new DwItemAttribute(this.i, 'VehicleId');
}

class RoMaintenanceMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Maintenance */
            Maintenance = new DwItemRelationship('roMaintenance|Maintenance|MaintenanceId', 'Maintenance', 'Maintenance');
            /** Relation: Vehicle */
            FleetVehicle = new DwItemRelationship('roMaintenance|Vehicle|VehicleId', 'FleetVehicle', 'FleetVehicle');
    };
export class RoVehicleMetaData implements DwItem2<RoVehicleEntity, RoVehicleMetaDataAttributes,RoVehicleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3438;
        this.ItemDetail.itemName='roVehicle';
        this.ItemDetail.keyName='VehicleId';
    }

    CreateEntity(): RoVehicleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoVehicleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoVehicleEntity, RoVehicleMetaDataAttributes,RoVehicleMetaDataRelations>(query, this);
    }
     Attributes = new RoVehicleMetaDataAttributes();
     Relations = new RoVehicleMetaDataRelations();

}


export type RoVehicleQueryBuilder = DwQueryBuilderGen<RoVehicleEntity, RoVehicleMetaDataAttributes,RoVehicleMetaDataRelations>


export class RoVehicleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roVehicle';
    // Attributes
    VehicleStatusCv = new DwItemAttribute(this.i, 'VehicleStatusCv');
    UnitId = new DwItemAttribute(this.i, 'UnitId');
    DriverName = new DwItemAttribute(this.i, 'DriverName');
    DriverUserId = new DwItemAttribute(this.i, 'DriverUserId');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    IsDot = new DwItemAttribute(this.i, 'IsDot');
    VehicleTypeCv = new DwItemAttribute(this.i, 'VehicleTypeCv');
    Year = new DwItemAttribute(this.i, 'Year');
    Make = new DwItemAttribute(this.i, 'Make');
    Model = new DwItemAttribute(this.i, 'Model');
    VIN = new DwItemAttribute(this.i, 'VIN');
    RegistrationStateProvinceId = new DwItemAttribute(this.i, 'RegistrationStateProvinceId');
    LicensePlate = new DwItemAttribute(this.i, 'LicensePlate');
    PlateExpirationDate = new DwItemAttribute(this.i, 'PlateExpirationDate');
    VehicleId = new DwItemAttribute(this.i, 'VehicleId');
    Phase = new DwItemAttribute(this.i, 'Phase');
    SortableUnitId = new DwItemAttribute(this.i, 'SortableUnitId');
    IsDotDisplay = new DwItemAttribute(this.i, 'IsDotDisplay');
    Unassigned = new DwItemAttribute(this.i, 'Unassigned');
}

class RoVehicleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Vehicle */
            FleetVehicle = new DwItemRelationship('roVehicle|Vehicle|VehicleId OLD', 'FleetVehicle', 'FleetVehicle');
    };
export class RoVehicleAccidentsMetaData implements DwItem2<RoVehicleAccidentsEntity, RoVehicleAccidentsMetaDataAttributes,RoVehicleAccidentsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=2519;
        this.ItemDetail.itemName='roVehicleAccidents';
        this.ItemDetail.keyName='';
    }

    CreateEntity(): RoVehicleAccidentsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoVehicleAccidentsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoVehicleAccidentsEntity, RoVehicleAccidentsMetaDataAttributes,RoVehicleAccidentsMetaDataRelations>(query, this);
    }
     Attributes = new RoVehicleAccidentsMetaDataAttributes();
     Relations = new RoVehicleAccidentsMetaDataRelations();

}


export type RoVehicleAccidentsQueryBuilder = DwQueryBuilderGen<RoVehicleAccidentsEntity, RoVehicleAccidentsMetaDataAttributes,RoVehicleAccidentsMetaDataRelations>


export class RoVehicleAccidentsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roVehicleAccidents';
    // Attributes
    VehicleAccidentId = new DwItemAttribute(this.i, 'VehicleAccidentId');
    EmployeeId = new DwItemAttribute(this.i, 'EmployeeId');
    PhoneNumber = new DwItemAttribute(this.i, 'PhoneNumber');
    WJID = new DwItemAttribute(this.i, 'WJID');
    AccidentDateTime = new DwItemAttribute(this.i, 'AccidentDateTime');
    AuthorityContacted = new DwItemAttribute(this.i, 'AuthorityContacted');
    ReportNumber = new DwItemAttribute(this.i, 'ReportNumber');
    DriverStreetAddress = new DwItemAttribute(this.i, 'DriverStreetAddress');
    DriverCity = new DwItemAttribute(this.i, 'DriverCity');
    DriverState = new DwItemAttribute(this.i, 'DriverState');
    DriverZip = new DwItemAttribute(this.i, 'DriverZip');
    AccidentAddress = new DwItemAttribute(this.i, 'AccidentAddress');
    AccidentCity = new DwItemAttribute(this.i, 'AccidentCity');
    AccidentState = new DwItemAttribute(this.i, 'AccidentState');
    AccidentZip = new DwItemAttribute(this.i, 'AccidentZip');
    AccidentTypeCv = new DwItemAttribute(this.i, 'AccidentTypeCv');
    AccidentAtFaultCv = new DwItemAttribute(this.i, 'AccidentAtFaultCv');
    VehicleRepairedCv = new DwItemAttribute(this.i, 'VehicleRepairedCv');
    Injuries = new DwItemAttribute(this.i, 'Injuries');
    OOPClaimExpense = new DwItemAttribute(this.i, 'OOPClaimExpense');
    InsurancePaidPDLTInsuredVehicle = new DwItemAttribute(this.i, 'InsurancePaidPDLTInsuredVehicle');
    InsurancePaidPDLTClaimantVehicle = new DwItemAttribute(this.i, 'InsurancePaidPDLTClaimantVehicle');
    OtherVehiclesInvolved = new DwItemAttribute(this.i, 'OtherVehiclesInvolved');
    IsDot = new DwItemAttribute(this.i, 'IsDot');
    AccidentDescription = new DwItemAttribute(this.i, 'AccidentDescription');
    AttachmentId = new DwItemAttribute(this.i, 'AttachmentId');
    ClaimNumber = new DwItemAttribute(this.i, 'ClaimNumber');
    ClaimStatusCv = new DwItemAttribute(this.i, 'ClaimStatusCv');
    ClaimInsuranceCompanyCv = new DwItemAttribute(this.i, 'ClaimInsuranceCompanyCv');
    ClaimInsuranceCompanyText = new DwItemAttribute(this.i, 'ClaimInsuranceCompanyText');
    AdvisorName = new DwItemAttribute(this.i, 'AdvisorName');
    AdvisorPhone = new DwItemAttribute(this.i, 'AdvisorPhone');
    ClaimFiledDate = new DwItemAttribute(this.i, 'ClaimFiledDate');
    ClaimComments = new DwItemAttribute(this.i, 'ClaimComments');
    CreatedbyEthosUserId = new DwItemAttribute(this.i, 'CreatedbyEthos_UserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByEthosUserId = new DwItemAttribute(this.i, 'ModifiedByEthos_UserId');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    SharepointMigrationId = new DwItemAttribute(this.i, 'SharepointMigrationId');
    AccidentDateMonth = new DwItemAttribute(this.i, 'AccidentDateMonth');
    StateDisplay = new DwItemAttribute(this.i, 'StateDisplay');
    IsPoliceReportObtained = new DwItemAttribute(this.i, 'IsPoliceReportObtained');
    ClaimNumberThirdParty = new DwItemAttribute(this.i, 'ClaimNumberThirdParty');
}

class RoVehicleAccidentsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class RoVehicleYearsMetaData implements DwItem2<RoVehicleYearsEntity, RoVehicleYearsMetaDataAttributes,RoVehicleYearsMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3415;
        this.ItemDetail.itemName='roVehicleYears';
        this.ItemDetail.keyName='Year';
    }

    CreateEntity(): RoVehicleYearsEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): RoVehicleYearsQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<RoVehicleYearsEntity, RoVehicleYearsMetaDataAttributes,RoVehicleYearsMetaDataRelations>(query, this);
    }
     Attributes = new RoVehicleYearsMetaDataAttributes();
     Relations = new RoVehicleYearsMetaDataRelations();

}


export type RoVehicleYearsQueryBuilder = DwQueryBuilderGen<RoVehicleYearsEntity, RoVehicleYearsMetaDataAttributes,RoVehicleYearsMetaDataRelations>


export class RoVehicleYearsMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'roVehicleYears';
    // Attributes
    Year = new DwItemAttribute(this.i, 'Year');
}

class RoVehicleYearsMetaDataRelations implements DwItemRelationshipCollection {
    };
export class ServiceTypeMetaData implements DwItem2<ServiceTypeEntity, ServiceTypeMetaDataAttributes,ServiceTypeMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3442;
        this.ItemDetail.itemName='ServiceType';
        this.ItemDetail.keyName='ServiceTypeId';
    }

    CreateEntity(): ServiceTypeEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): ServiceTypeQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<ServiceTypeEntity, ServiceTypeMetaDataAttributes,ServiceTypeMetaDataRelations>(query, this);
    }
     Attributes = new ServiceTypeMetaDataAttributes();
     Relations = new ServiceTypeMetaDataRelations();

}


export type ServiceTypeQueryBuilder = DwQueryBuilderGen<ServiceTypeEntity, ServiceTypeMetaDataAttributes,ServiceTypeMetaDataRelations>


export class ServiceTypeMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'ServiceType';
    // Attributes
    ServiceTypeId = new DwItemAttribute(this.i, 'ServiceTypeId');
    Display = new DwItemAttribute(this.i, 'Display');
}

class ServiceTypeMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Maintenance Service */
            MaintenanceService = new DwItemRelationship('ServiceType|MaintenanceService|ServiceTypeId', 'MaintenanceService', 'MaintenanceService');
    };
export class FleetVehicleMetaData implements DwItem2<FleetVehicleEntity, FleetVehicleMetaDataAttributes,FleetVehicleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();

    constructor() {
        this.ItemDetail.itemId=3431;
        this.ItemDetail.itemName='fleet_Vehicle';
        this.ItemDetail.keyName='VehicleId';
    }

    CreateEntity(): FleetVehicleEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilder(query ?: DwQuery): FleetVehicleQueryBuilder  {
           if (!query)
           {
                  query = new DwQuery(this.ItemDetail.itemName);
            }
           return new DwQueryBuilderGen<FleetVehicleEntity, FleetVehicleMetaDataAttributes,FleetVehicleMetaDataRelations>(query, this);
    }
     Attributes = new FleetVehicleMetaDataAttributes();
     Relations = new FleetVehicleMetaDataRelations();

}


export type FleetVehicleQueryBuilder = DwQueryBuilderGen<FleetVehicleEntity, FleetVehicleMetaDataAttributes,FleetVehicleMetaDataRelations>


export class FleetVehicleMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'fleet_Vehicle';
    // Attributes
    AdditionalDriverUserId = new DwItemAttribute(this.i, 'AdditionalDriverUserId');
    AnnualInspectionExpirationDate = new DwItemAttribute(this.i, 'AnnualInspectionExpirationDate');
    CameraSerialNumber = new DwItemAttribute(this.i, 'CameraSerialNumber');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    DielectricInspectionExpirationDate = new DwItemAttribute(this.i, 'DielectricInspectionExpirationDate');
    DotInspectionDate = new DwItemAttribute(this.i, 'DotInspectionDate');
    DriverAlertId = new DwItemAttribute(this.i, 'DriverAlertId');
    DriverUserId = new DwItemAttribute(this.i, 'DriverUserId');
    DriveTrainCv = new DwItemAttribute(this.i, 'DriveTrainCv');
    FuelCardId = new DwItemAttribute(this.i, 'FuelCardId');
    FuelTypeCv = new DwItemAttribute(this.i, 'FuelTypeCv');
    GpsId = new DwItemAttribute(this.i, 'GpsId');
    GVWR = new DwItemAttribute(this.i, 'GVWR');
    HasGps = new DwItemAttribute(this.i, 'HasGps');
    InsuranceExpirationDate = new DwItemAttribute(this.i, 'InsuranceExpirationDate');
    IsDot = new DwItemAttribute(this.i, 'IsDot');
    IsEmployee = new DwItemAttribute(this.i, 'IsEmployee');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    LicensePlate = new DwItemAttribute(this.i, 'LicensePlate');
    Make = new DwItemAttribute(this.i, 'Make');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    Model = new DwItemAttribute(this.i, 'Model');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    ModifiedByUserId = new DwItemAttribute(this.i, 'ModifiedByUserId');
    NoteParentId = new DwItemAttribute(this.i, 'NoteParentId');
    OwnershipTypeCv = new DwItemAttribute(this.i, 'OwnershipTypeCv');
    PafEffectiveDate = new DwItemAttribute(this.i, 'PafEffectiveDate');
    PafNotes = new DwItemAttribute(this.i, 'PafNotes');
    PassAccountName = new DwItemAttribute(this.i, 'PassAccountName');
    PassAccountNumber = new DwItemAttribute(this.i, 'PassAccountNumber');
    PassActivationDate = new DwItemAttribute(this.i, 'PassActivationDate');
    Phase = new DwItemAttribute(this.i, 'Phase');
    PlateExpirationDate = new DwItemAttribute(this.i, 'PlateExpirationDate');
    PurchaseDate = new DwItemAttribute(this.i, 'PurchaseDate');
    PurchasePrice = new DwItemAttribute(this.i, 'PurchasePrice');
    RawDriverName = new DwItemAttribute(this.i, 'RawDriverName');
    RegistrationStateProvinceId = new DwItemAttribute(this.i, 'RegistrationStateProvinceId');
    SendPaf = new DwItemAttribute(this.i, 'SendPaf');
    SharepointId = new DwItemAttribute(this.i, 'SharepointId');
    SpJobNumber = new DwItemAttribute(this.i, 'SpJobNumber');
    TransponderSerialNumber = new DwItemAttribute(this.i, 'TransponderSerialNumber');
    UnitId = new DwItemAttribute(this.i, 'UnitId');
    VehicleId = new DwItemAttribute(this.i, 'VehicleId');
    VehicleStatusCv = new DwItemAttribute(this.i, 'VehicleStatusCv');
    VehicleTypeCv = new DwItemAttribute(this.i, 'VehicleTypeCv');
    VIN = new DwItemAttribute(this.i, 'VIN');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    Year = new DwItemAttribute(this.i, 'Year');
}

class FleetVehicleMetaDataRelations implements DwItemRelationshipCollection {
            /** Relation: Trust Code Value - Status */
            CodeValueByVehicleStatusCv = new DwItemRelationship('CodeValue|fleet_Vehicle|VehicleStatusCv', 'VehicleStatusCvCodeValue', 'VehicleStatusCvCodeValue');
            /** Relation: Trust Code Value - Vehicle Type */
            CodeValueByVehicleTypeCv = new DwItemRelationship('CodeValue|fleet_Vehicle|VehicleTypeCv', 'VehicleTypeCvCodeValue', 'VehicleTypeCvCodeValue');
            /** Relation: Trust Code Value - Ownership Type */
            CodeValueByOwnershipTypeCv = new DwItemRelationship('CodeValue|fleet_Vehicle|OwnershipTypeCv', 'OwnershipTypeCvCodeValue', 'OwnershipTypeCvCodeValue');
            /** Relation: Trust Code Value - Drive Train */
            CodeValueByDriveTrainCv = new DwItemRelationship('CodeValue|fleet_Vehicle|DriveTrainCv', 'DriveTrainCvCodeValue', 'DriveTrainCvCodeValue');
            /** Relation: Job Number */
            EthosJobNumber = new DwItemRelationship('Ethos_JobNumber|fleet_Vehicle|JobNumberId', 'EthosJobNumber', 'EthosJobNumber');
            /** Relation: Ethos User - Driver User */
            EthosUserByDriverUserId = new DwItemRelationship('Ethos_User|fleet_Vehicle|DriverUserId', 'DriverEthosUser', 'DriverEthosUser');
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId = new DwItemRelationship('Ethos_User|fleet_Vehicle|CreatedByUserId', 'CreatedByEthosUser', 'CreatedByEthosUser');
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId = new DwItemRelationship('Ethos_User|fleet_Vehicle|ModifiedByUserId', 'ModifiedByEthosUser', 'ModifiedByEthosUser');
            /** Relation: Ethos User - Additional Driver User */
            EthosUserByAdditionalDriverUserId = new DwItemRelationship('Ethos_User|fleet_Vehicle|AdditionalDriverUserId', 'AdditionalDriverEthosUser', 'AdditionalDriverEthosUser');
            /** Relation: Wachter Department */
            EthosWachterDepartment = new DwItemRelationship('Ethos_WachterDepartment|fleet_Vehicle|WachterDepartmentId', 'EthosWachterDepartment', 'EthosWachterDepartment');
            /** Relation: Auction */
            Auction = new DwItemRelationship('fleet_Vehicle|Auction|VehicleId', 'Auction', 'Auction');
            /** Relation: Maintenance */
            Maintenance = new DwItemRelationship('fleet_Vehicle|Maintenance|VehicleId', 'Maintenance', 'Maintenance');
            /** Relation: Paf History */
            PafHistory = new DwItemRelationship('fleet_Vehicle|PafHistory|VehicleId', 'PafHistory', 'PafHistory');
            /** Relation: Ro Maintenance */
            RoMaintenance = new DwItemRelationship('roMaintenance|Vehicle|VehicleId', 'RoMaintenance', 'RoMaintenance');
            /** Relation: Ro Vehicle */
            RoVehicle = new DwItemRelationship('roVehicle|Vehicle|VehicleId OLD', 'RoVehicle', 'RoVehicle');
    };
// Generated Query Classes for MetaData Service
export class FleetAuctionGridQueryQueryMetaData implements DwItem2<FleetAuctionGridQueryQueryEntity, FleetAuctionGridQueryQueryMetaDataAttributes,AuctionMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Fleet_Auction_Grid_Query';

    constructor() {
        this.ItemDetail.itemId=3434;
        this.ItemDetail.itemName='Auction';
        this.ItemDetail.keyName='AuctionId';
    }

    CreateEntity(): FleetAuctionGridQueryQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FleetAuctionGridQueryQueryBuilder {
        return new DwQueryBuilderGen<FleetAuctionGridQueryQueryEntity, FleetAuctionGridQueryQueryMetaDataAttributes,AuctionMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FleetAuctionGridQueryQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FleetAuctionGridQueryQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FleetAuctionGridQueryQueryEntity, FleetAuctionGridQueryQueryMetaDataAttributes,AuctionMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FleetAuctionGridQueryQueryMetaDataAttributes();
     Relations = new AuctionMetaDataRelations();

}


export type FleetAuctionGridQueryQueryBuilder = DwQueryBuilderGen<FleetAuctionGridQueryQueryEntity, FleetAuctionGridQueryQueryMetaDataAttributes,AuctionMetaDataRelations>


export class FleetAuctionGridQueryQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'Auction';
    // Attributes
    AuctionId = new DwItemAttribute(this.i, 'AuctionId');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    ModifiedByUserId = new DwItemAttribute(this.i, 'ModifiedByUserId');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    SharepointId = new DwItemAttribute(this.i, 'SharepointId');
    VehicleId = new DwItemAttribute(this.i, 'VehicleId');
    Color = new DwItemAttribute(this.i, 'Color');
    Mileage = new DwItemAttribute(this.i, 'Mileage');
    ConditionCv = new DwItemAttribute(this.i, 'ConditionCv');
    Duration = new DwItemAttribute(this.i, 'Duration');
    LegacyUnitId = new DwItemAttribute(this.i, 'LegacyUnitId');
    Description = new DwItemAttribute(this.i, 'Description');
    StatusCv = new DwItemAttribute(this.i, 'StatusCv');
    LocationCity = new DwItemAttribute(this.i, 'LocationCity');
    LocationStateProvinceId = new DwItemAttribute(this.i, 'LocationStateProvinceId');
    LocationZip = new DwItemAttribute(this.i, 'LocationZip');
    StartingPrice = new DwItemAttribute(this.i, 'StartingPrice');
    Title = new DwItemAttribute(this.i, 'Title');
    EndDateTime = new DwItemAttribute(this.i, 'EndDateTime');
    StartDateTime = new DwItemAttribute(this.i, 'StartDateTime');
    FleetVehicleYear = new DwItemAttribute('fleet_Vehicle', 'FleetVehicleYear');
    FleetVehicleMake = new DwItemAttribute('fleet_Vehicle', 'FleetVehicleMake');
    FleetVehicleModel = new DwItemAttribute('fleet_Vehicle', 'FleetVehicleModel');
    FleetVehicleVehicleTypeCv = new DwItemAttribute('fleet_Vehicle', 'FleetVehicleVehicleTypeCv');
    RoVehicleUnitId = new DwItemAttribute('roVehicle', 'RoVehicleUnitId');
    RoVehicleSortableUnitId = new DwItemAttribute('roVehicle', 'RoVehicleSortableUnitId');
    RoVehicleWachterDepartmentId = new DwItemAttribute('roVehicle', 'RoVehicleWachterDepartmentId');
    RoAuctionCurrentBid = new DwItemAttribute('roAuction', 'RoAuctionCurrentBid');
    RoAuctionFinalBid = new DwItemAttribute('roAuction', 'RoAuctionFinalBid');
}
export class FleetVehicleGridQueryQueryMetaData implements DwItem2<FleetVehicleGridQueryQueryEntity, FleetVehicleGridQueryQueryMetaDataAttributes,FleetVehicleMetaDataRelations> {
    ItemDetail: DwItemDetail2 = new DwItemDetail2();
    QueryMeaning = 'Fleet_Vehicle_Grid_Query';

    constructor() {
        this.ItemDetail.itemId=3431;
        this.ItemDetail.itemName='fleet_Vehicle';
        this.ItemDetail.keyName='VehicleId';
    }

    CreateEntity(): FleetVehicleGridQueryQueryEntity {
            return {
                _itemName: this.ItemDetail.itemName,
                _keyName: this.ItemDetail.keyName
            };
    }

    CreateQueryBuilderFromQuery(query: DwQuery): FleetVehicleGridQueryQueryBuilder {
        return new DwQueryBuilderGen<FleetVehicleGridQueryQueryEntity, FleetVehicleGridQueryQueryMetaDataAttributes,FleetVehicleMetaDataRelations>(query, this);
    }

    CreateQueryBuilder(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<FleetVehicleGridQueryQueryBuilder> {
        return this.CreateQueryBuilderWithMetaData(dwMetaDataService).pipe(map(result => result.queryBuilder));
    }

    CreateQueryBuilderWithMetaData(dwMetaDataService: EnterpriseMetaData.DwMetaDataService): Observable<{queryMetaData: EnterpriseMetaData.DwQueryMetaData, queryBuilder: FleetVehicleGridQueryQueryBuilder}> {
        return dwMetaDataService.getSavedQueryMetaData(this.ItemDetail.itemName, null, this.QueryMeaning).pipe(map(queryMetaData =>
        {
            return { queryMetaData: queryMetaData, queryBuilder: new DwQueryBuilderGen<FleetVehicleGridQueryQueryEntity, FleetVehicleGridQueryQueryMetaDataAttributes,FleetVehicleMetaDataRelations>(queryMetaData.DataQuery, this) };
        }));
    }
     Attributes = new FleetVehicleGridQueryQueryMetaDataAttributes();
     Relations = new FleetVehicleMetaDataRelations();

}


export type FleetVehicleGridQueryQueryBuilder = DwQueryBuilderGen<FleetVehicleGridQueryQueryEntity, FleetVehicleGridQueryQueryMetaDataAttributes,FleetVehicleMetaDataRelations>


export class FleetVehicleGridQueryQueryMetaDataAttributes implements DwItemAttributeCollection {
    //shortcut to item name - to reduce file size
    private i : string = 'fleet_Vehicle';
    // Attributes
    AdditionalDriverUserId = new DwItemAttribute(this.i, 'AdditionalDriverUserId');
    AnnualInspectionExpirationDate = new DwItemAttribute(this.i, 'AnnualInspectionExpirationDate');
    CameraSerialNumber = new DwItemAttribute(this.i, 'CameraSerialNumber');
    CreatedByDateTime = new DwItemAttribute(this.i, 'CreatedByDateTime');
    CreatedByUserId = new DwItemAttribute(this.i, 'CreatedByUserId');
    DielectricInspectionExpirationDate = new DwItemAttribute(this.i, 'DielectricInspectionExpirationDate');
    DotInspectionDate = new DwItemAttribute(this.i, 'DotInspectionDate');
    DriverAlertId = new DwItemAttribute(this.i, 'DriverAlertId');
    DriverUserId = new DwItemAttribute(this.i, 'DriverUserId');
    DriveTrainCv = new DwItemAttribute(this.i, 'DriveTrainCv');
    FuelCardId = new DwItemAttribute(this.i, 'FuelCardId');
    FuelTypeCv = new DwItemAttribute(this.i, 'FuelTypeCv');
    GpsId = new DwItemAttribute(this.i, 'GpsId');
    GVWR = new DwItemAttribute(this.i, 'GVWR');
    HasGps = new DwItemAttribute(this.i, 'HasGps');
    InsuranceExpirationDate = new DwItemAttribute(this.i, 'InsuranceExpirationDate');
    IsDot = new DwItemAttribute(this.i, 'IsDot');
    IsEmployee = new DwItemAttribute(this.i, 'IsEmployee');
    JobNumberId = new DwItemAttribute(this.i, 'JobNumberId');
    LicensePlate = new DwItemAttribute(this.i, 'LicensePlate');
    Make = new DwItemAttribute(this.i, 'Make');
    MediaGroupId = new DwItemAttribute(this.i, 'MediaGroupId');
    Model = new DwItemAttribute(this.i, 'Model');
    ModifiedByDateTime = new DwItemAttribute(this.i, 'ModifiedByDateTime');
    ModifiedByUserId = new DwItemAttribute(this.i, 'ModifiedByUserId');
    NoteParentId = new DwItemAttribute(this.i, 'NoteParentId');
    OwnershipTypeCv = new DwItemAttribute(this.i, 'OwnershipTypeCv');
    PafEffectiveDate = new DwItemAttribute(this.i, 'PafEffectiveDate');
    PafNotes = new DwItemAttribute(this.i, 'PafNotes');
    PassAccountName = new DwItemAttribute(this.i, 'PassAccountName');
    PassAccountNumber = new DwItemAttribute(this.i, 'PassAccountNumber');
    PassActivationDate = new DwItemAttribute(this.i, 'PassActivationDate');
    Phase = new DwItemAttribute(this.i, 'Phase');
    PlateExpirationDate = new DwItemAttribute(this.i, 'PlateExpirationDate');
    PurchaseDate = new DwItemAttribute(this.i, 'PurchaseDate');
    PurchasePrice = new DwItemAttribute(this.i, 'PurchasePrice');
    RawDriverName = new DwItemAttribute(this.i, 'RawDriverName');
    RegistrationStateProvinceId = new DwItemAttribute(this.i, 'RegistrationStateProvinceId');
    SendPaf = new DwItemAttribute(this.i, 'SendPaf');
    SharepointId = new DwItemAttribute(this.i, 'SharepointId');
    SpJobNumber = new DwItemAttribute(this.i, 'SpJobNumber');
    TransponderSerialNumber = new DwItemAttribute(this.i, 'TransponderSerialNumber');
    UnitId = new DwItemAttribute(this.i, 'UnitId');
    VehicleId = new DwItemAttribute(this.i, 'VehicleId');
    VehicleStatusCv = new DwItemAttribute(this.i, 'VehicleStatusCv');
    VehicleTypeCv = new DwItemAttribute(this.i, 'VehicleTypeCv');
    VIN = new DwItemAttribute(this.i, 'VIN');
    WachterDepartmentId = new DwItemAttribute(this.i, 'WachterDepartmentId');
    Year = new DwItemAttribute(this.i, 'Year');
    // Attribute code name is not unique - appending Meta Data Attribute Id;
    DotInspectionDate_29157 = new DwItemAttribute(this.i, 'DotInspectionDate');
    RoVehicleDriverName = new DwItemAttribute('roVehicle', 'RoVehicleDriverName');
    RoVehicleSortableUnitId = new DwItemAttribute('roVehicle', 'RoVehicleSortableUnitId');
    RoVehiclePhase = new DwItemAttribute('roVehicle', 'RoVehiclePhase');
    RoVehicleIsDotDisplay = new DwItemAttribute('roVehicle', 'RoVehicleIsDotDisplay');
    RoVehicleUnassigned = new DwItemAttribute('roVehicle', 'RoVehicleUnassigned');
    DepartmentMapGroup = new DwItemAttribute('DepartmentMap', 'DepartmentMapGroup');
}


// Generated Query Classes for MetaData Service

class MetaDataQueries {
    FleetAuctionGridQuery : FleetAuctionGridQueryQueryMetaData = new FleetAuctionGridQueryQueryMetaData();
    FleetVehicleGridQuery : FleetVehicleGridQueryQueryMetaData = new FleetVehicleGridQueryQueryMetaData();
}

export class FleetMetaData {

    static Auction : AuctionMetaData = new AuctionMetaData();
    static BidHistory : BidHistoryMetaData = new BidHistoryMetaData();
    static CodeValue : CodeValueMetaData = new CodeValueMetaData();
    static DepartmentMap : DepartmentMapMetaData = new DepartmentMapMetaData();
    static EmployeeServiceDates : EmployeeServiceDatesMetaData = new EmployeeServiceDatesMetaData();
    static EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    static EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    static EthosJobNumber : EthosJobNumberMetaData = new EthosJobNumberMetaData();
    static EthosJobNumberForecast : EthosJobNumberForecastMetaData = new EthosJobNumberForecastMetaData();
    static EthosJobNumberMembership : EthosJobNumberMembershipMetaData = new EthosJobNumberMembershipMetaData();
    static EthosJobNumberPhase : EthosJobNumberPhaseMetaData = new EthosJobNumberPhaseMetaData();
    static EthosJobNumberPriority : EthosJobNumberPriorityMetaData = new EthosJobNumberPriorityMetaData();
    static EthosServiceUser : EthosServiceUserMetaData = new EthosServiceUserMetaData();
    static EthosUser : EthosUserMetaData = new EthosUserMetaData();
    static EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    static EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    static EthosWachterDepartment : EthosWachterDepartmentMetaData = new EthosWachterDepartmentMetaData();
    static Maintenance : MaintenanceMetaData = new MaintenanceMetaData();
    static MaintenanceService : MaintenanceServiceMetaData = new MaintenanceServiceMetaData();
    static PafHistory : PafHistoryMetaData = new PafHistoryMetaData();
    static RoAuction : RoAuctionMetaData = new RoAuctionMetaData();
    static RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    static RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    static RoMaintenance : RoMaintenanceMetaData = new RoMaintenanceMetaData();
    static RoVehicle : RoVehicleMetaData = new RoVehicleMetaData();
    static RoVehicleAccidents : RoVehicleAccidentsMetaData = new RoVehicleAccidentsMetaData();
    static RoVehicleYears : RoVehicleYearsMetaData = new RoVehicleYearsMetaData();
    static ServiceType : ServiceTypeMetaData = new ServiceTypeMetaData();
    static FleetVehicle : FleetVehicleMetaData = new FleetVehicleMetaData();
    static Queries = new MetaDataQueries();
}
// Generated Entity Interfaces
export interface AuctionEntity extends DwOrmData {
    // Attributes
    AuctionId?: number;
    CreatedByUserId?: number;
    ModifiedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    SharepointId?: number;
    VehicleId?: number;
    Color?: string;
    Mileage?: number;
    ConditionCv?: number;
    Duration?: number;
    LegacyUnitId?: string;
    Description?: string;
    StatusCv?: number;
    LocationCity?: string;
    LocationStateProvinceId?: number;
    LocationZip?: string;
    StartingPrice?: number;
    StartDateTime?: string;
    FinalPrice?: number;
    NoteParentId?: number;
    MediaGroupId?: number;
    Title?: string;
    EndDateTime?: string;

    // Display Attributes
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;
    VehicleIdDisplay?: string;
    ConditionCvDisplay?: string;
    StatusCvDisplay?: string;
    LocationStateProvinceIdDisplay?: string;
    NoteParentIdDisplay?: string;

    // Relations
    ConditionCvCodeValue? : CodeValueEntity;
    StatusCvCodeValue? : CodeValueEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
    BidHistory? : BidHistoryEntity[];
    RoAuction? : RoAuctionEntity[];
}

export interface BidHistoryEntity extends DwOrmData {
    // Attributes
    BidHistoryId?: number;
    AuctionId?: number;
    BidderName?: string;
    Amount?: number;
    Notes?: string;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;
    AppUserId?: number;

    // Display Attributes
    AuctionIdDisplay?: string;
    CreatedByUserIdDisplay?: string;

    // Relations
    Auction? : AuctionEntity;
    CreatedByEthosUser? : EthosUserEntity;
}

export interface CodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    ConditionCvAuction? : AuctionEntity[];
    StatusCvAuction? : AuctionEntity[];
    VehicleStatusCvFleetVehicle? : FleetVehicleEntity[];
    VehicleTypeCvFleetVehicle? : FleetVehicleEntity[];
    OwnershipTypeCvFleetVehicle? : FleetVehicleEntity[];
    DriveTrainCvFleetVehicle? : FleetVehicleEntity[];
}

export interface DepartmentMapEntity extends DwOrmData {
    // Attributes
    DepartmentMapId?: number;
    WachterDepartmentId?: number;
    Group?: string;

    // Display Attributes
    WachterDepartmentIdDisplay?: string;

    // Relations
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
}

export interface EmployeeServiceDatesEntity extends DwOrmData {
    // Attributes
    PersonnelNumber?: string;
    HireDate?: string;
    EmploymentStartDate?: string;
    AdjustedServiceDate?: string;


    // Relations
}

export interface EthosCodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;
    ImagePath?: string;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    InvoiceDeliveryTypeCVEthosJobNumber? : EthosJobNumberEntity[];
    ForecastStatusCvEthosJobNumber? : EthosJobNumberEntity[];
    JobNumberTypeCvEthosJobNumber? : EthosJobNumberEntity[];
    UserTypeCvEthosUser? : EthosUserEntity[];
    // Duplicate property excluded
    // UserTypeCvEthosUser : EthosUserEntity[];
    ResourceGroupCvEthosUser? : EthosUserEntity[];
    SkillCvEthosUserSkill? : EthosUserSkillEntity[];
    DepartmentTypeCvEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    ResourceGroupCvRoEthosUser? : RoEthosUserEntity[];
    UserTypeCvRoEthosUser? : RoEthosUserEntity[];
}

export interface EthosCodeValueCustomEntity extends DwOrmData {
    // Attributes
    CodeValueCustomId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
}

export interface EthosJobNumberEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    JobNumberStatusWs?: number;
    JobNumberStatus?: string;
    JobNumber?: string;
    CustomerId?: number;
    JobName?: string;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr2UserId?: number;
    AsstProjectMgrUserId?: number;
    SeniorMgrUserId?: number;
    LeadTech1UserId?: number;
    LeadTech2UserId?: number;
    InvoiceApproval1UserId?: number;
    InvoiceApproval2UserId?: number;
    ForecastStatusCv?: number;
    ForecastStatus?: string;
    WachterTeamId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    BillingInstructions?: string;
    ChangeOrderProcessInstructions?: string;
    PartialBilling?: boolean;
    FinalInvoiceDate?: string;
    InvoiceDeliveryTypeData?: string;
    InvoiceDeliveryTypeCV?: number;
    OpportunityId?: number;
    EndCustomerId?: number;
    LookUpKey?: number;
    IsDeleted?: boolean;
    JobNumberTypeCv?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectMgr1UserIdDisplay?: string;
    ProjectMgr2UserIdDisplay?: string;
    AsstProjectMgrUserIdDisplay?: string;
    SeniorMgrUserIdDisplay?: string;
    LeadTech1UserIdDisplay?: string;
    LeadTech2UserIdDisplay?: string;
    InvoiceApproval1UserIdDisplay?: string;
    InvoiceApproval2UserIdDisplay?: string;
    ForecastStatusCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    InvoiceDeliveryTypeCVDisplay?: string;
    OpportunityIdDisplay?: string;
    EndCustomerIdDisplay?: string;
    JobNumberTypeCvDisplay?: string;

    // Relations
    InvoiceDeliveryTypeCVEthosCodeValue? : EthosCodeValueEntity;
    ForecastStatusCvEthosCodeValue? : EthosCodeValueEntity;
    JobNumberTypeCvEthosCodeValue? : EthosCodeValueEntity;
    ProjectMgr1EthosUser? : EthosUserEntity;
    ProjectMgr2EthosUser? : EthosUserEntity;
    AsstProjectMgrEthosUser? : EthosUserEntity;
    SeniorMgrEthosUser? : EthosUserEntity;
    LeadTech1EthosUser? : EthosUserEntity;
    LeadTech2EthosUser? : EthosUserEntity;
    InvoiceApproval1EthosUser? : EthosUserEntity;
    InvoiceApproval2EthosUser? : EthosUserEntity;
    EthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    EthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    UserIdEthosUser? : EthosUserEntity[];
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    Maintenance? : MaintenanceEntity[];
    FleetVehicle? : FleetVehicleEntity[];
}

export interface EthosJobNumberForecastEntity extends DwOrmData {
    // Attributes
    JobNumberForecastId?: number;
    JobNumberId?: number;
    YeProjectedCosts?: number;
    YeProjectedRevenue?: number;
    IsDeleted?: boolean;
    CreatedBy?: number;
    ModifiedBy?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    Notes?: string;
    NoteAgingOverSixtyDays?: string;
    NoteOverUnderBilling?: string;
    NoteLowForecastedGpm?: string;
    NoteChangedGpm?: string;
    AXIntegrationID?: string;
    TotalForecastRevenue?: number;
    TotalForecastCost?: number;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
}

export interface EthosJobNumberMembershipEntity extends DwOrmData {
    // Attributes
    JobNumberMembershipId?: number;
    UserId?: number;
    JobNumberId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    JobNumberIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosJobNumberPhaseEntity extends DwOrmData {
    // Attributes
    JobNumberPhaseId?: number;
    JobNumberId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    IsVisible?: boolean;
    IsOnSite?: boolean;
    IsEstimate?: boolean;
    JobNumberPhaseStatusWs?: number;
    WorkflowStatusDisplay?: string;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberPhaseStatusWsDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
}

export interface EthosJobNumberPriorityEntity extends DwOrmData {
    // Attributes
    JobNumberPriorityId?: number;
    JobNumberId?: number;
    PriorityName?: string;
    IsDeleted?: boolean;
    ResponseTimeInHours?: number;
    StraightHourlyBillingRate?: number;
    OvertimeHourlyBillingRate?: number;
    HolidayHourlyBillingRate?: number;
    TravelHourlyBillingRate?: number;
    MileageBillingRate?: number;
    MaxTravelInHours?: number;
    CreatedDateTime?: string;
    CreatedByUserId?: number;
    ModifiedDateTime?: string;
    ModifiedByUserId?: number;
    TripCharge?: number;
    ExpediteFee?: number;
    IsEscalationEnabled?: boolean;
    SendPriorityNotification?: boolean;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
}

export interface EthosServiceUserEntity extends DwOrmData {
    // Attributes
    EthosServiceUserId?: number;
    Ethos_UserId?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    CustomerIdDisplay?: string;

    // Relations
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    // Duplicate property excluded
    // UserTypeCvEthosCodeValue : EthosCodeValueEntity;
    ResourceGroupCvEthosCodeValue? : EthosCodeValueEntity;
    UserIdEthosJobNumber? : EthosJobNumberEntity;
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity[];
    CreatedByAuction? : AuctionEntity[];
    ModifiedByAuction? : AuctionEntity[];
    CreatedByBidHistory? : BidHistoryEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    ProjectMgr1EthosJobNumber? : EthosJobNumberEntity[];
    ProjectMgr2EthosJobNumber? : EthosJobNumberEntity[];
    AsstProjectMgrEthosJobNumber? : EthosJobNumberEntity[];
    SeniorMgrEthosJobNumber? : EthosJobNumberEntity[];
    LeadTech1EthosJobNumber? : EthosJobNumberEntity[];
    LeadTech2EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval1EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval2EthosJobNumber? : EthosJobNumberEntity[];
    CreatedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    ModifiedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    CreatedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    ModifiedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    EthosEthosServiceUser? : EthosServiceUserEntity[];
    EthosEthosUserDiff? : EthosUserDiffEntity[];
    EthosUserSkill? : EthosUserSkillEntity[];
    DepartmentDirectorEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    DepartmentAsstManagerEthosWachterDepartment? : EthosWachterDepartmentEntity[];
    CreatedByMaintenance? : MaintenanceEntity[];
    ModifiedByMaintenance? : MaintenanceEntity[];
    DriverMaintenance? : MaintenanceEntity[];
    CreatedByPafHistory? : PafHistoryEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    DriverFleetVehicle? : FleetVehicleEntity[];
    CreatedByFleetVehicle? : FleetVehicleEntity[];
    ModifiedByFleetVehicle? : FleetVehicleEntity[];
    AdditionalDriverFleetVehicle? : FleetVehicleEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Meaning?: string;
    Display?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SkillCvDisplay?: string;

    // Relations
    SkillCvEthosCodeValue? : EthosCodeValueEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosWachterDepartmentEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    DepartmentTypeCv?: number;
    DepartmentTypeMeaning?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    DepartmentDirectorUserId?: number;
    IsDeleted?: boolean;
    DepartmentManagerUserId?: number;
    DepartmentAsstManagerUserId?: number;
    JobNumberId?: number;
    AxIntegrationId?: string;
    JobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    DepartmentTypeCvDisplay?: string;
    DepartmentDirectorUserIdDisplay?: string;
    DepartmentManagerUserIdDisplay?: string;
    DepartmentAsstManagerUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    JobNumberPhaseIdDisplay?: string;

    // Relations
    DepartmentTypeCvEthosCodeValue? : EthosCodeValueEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity;
    DepartmentDirectorEthosUser? : EthosUserEntity;
    DepartmentManagerEthosUser? : EthosUserEntity;
    DepartmentAsstManagerEthosUser? : EthosUserEntity;
    DepartmentMap? : DepartmentMapEntity[];
    EthosUser? : EthosUserEntity;
    RoEthosUser? : RoEthosUserEntity[];
    FleetVehicle? : FleetVehicleEntity[];
}

export interface MaintenanceEntity extends DwOrmData {
    // Attributes
    MaintenanceId?: number;
    CreatedByUserId?: number;
    ModifiedByUserId?: number;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    SharepointId?: number;
    VehicleId?: number;
    Date?: string;
    DriverUserId?: number;
    RawDriverName?: string;
    JobNumberId?: number;
    Odometer?: number;
    Cost?: number;
    PONumber?: string;
    ServiceProvider?: string;
    ServiceType?: string;
    CurrentLicensePlate?: string;
    NoteParentId?: number;
    MediaGroupId?: number;
    Phase?: string;
    IsEmployee?: boolean;

    // Display Attributes
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;
    VehicleIdDisplay?: string;
    DriverUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    NoteParentIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    DriverEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
    MaintenanceService? : MaintenanceServiceEntity[];
    RoMaintenance? : RoMaintenanceEntity[];
}

export interface MaintenanceServiceEntity extends DwOrmData {
    // Attributes
    MaintenanceServiceId?: number;
    MaintenanceId?: number;
    ServiceTypeId?: number;

    // Display Attributes
    MaintenanceIdDisplay?: string;
    ServiceTypeIdDisplay?: string;

    // Relations
    Maintenance? : MaintenanceEntity;
    ServiceType? : ServiceTypeEntity;
}

export interface PafHistoryEntity extends DwOrmData {
    // Attributes
    PafHistoryId?: number;
    VehicleId?: number;
    Note?: string;
    CreatedByUserId?: number;
    CreatedByDateTime?: string;

    // Display Attributes
    VehicleIdDisplay?: string;
    CreatedByUserIdDisplay?: string;

    // Relations
    CreatedByEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
}

export interface RoAuctionEntity extends DwOrmData {
    // Attributes
    AuctionId?: number;
    CurrentBid?: number;
    FinalBid?: number;
    CreatedByUserId?: number;
    StatusCv?: number;
    AppUserId?: number;

    // Display Attributes
    AuctionIdDisplay?: string;
    StatusCvDisplay?: string;

    // Relations
    Auction? : AuctionEntity;
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    ResourceGroupCvEthosCodeValue? : EthosCodeValueEntity;
    UserTypeCvEthosCodeValue? : EthosCodeValueEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity;
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: number;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;


    // Relations
}

export interface RoMaintenanceEntity extends DwOrmData {
    // Attributes
    MaintenanceId?: number;
    SortableUnitId?: number;
    DriverName?: string;
    JobNumberId?: number;
    VIN?: string;
    VehicleId?: number;

    // Display Attributes
    MaintenanceIdDisplay?: string;
    JobNumberIdDisplay?: string;
    VehicleIdDisplay?: string;

    // Relations
    Maintenance? : MaintenanceEntity;
    FleetVehicle? : FleetVehicleEntity;
}

export interface RoVehicleEntity extends DwOrmData {
    // Attributes
    VehicleStatusCv?: number;
    UnitId?: string;
    DriverName?: string;
    DriverUserId?: number;
    JobNumberId?: number;
    WachterDepartmentId?: number;
    IsDot?: boolean;
    VehicleTypeCv?: number;
    Year?: number;
    Make?: string;
    Model?: string;
    VIN?: string;
    RegistrationStateProvinceId?: number;
    LicensePlate?: string;
    PlateExpirationDate?: string;
    VehicleId?: number;
    Phase?: string;
    SortableUnitId?: number;
    IsDotDisplay?: string;
    Unassigned?: boolean;

    // Display Attributes
    VehicleStatusCvDisplay?: string;
    UnitIdDisplay?: string;
    DriverNameDisplay?: string;
    DriverUserIdDisplay?: string;
    JobNumberIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    VehicleTypeCvDisplay?: string;
    YearDisplay?: string;
    RegistrationStateProvinceIdDisplay?: string;
    VehicleIdDisplay?: string;

    // Relations
    FleetVehicle? : FleetVehicleEntity;
    // Duplicate property excluded
    // FleetVehicle : FleetVehicleEntity;
}

export interface RoVehicleAccidentsEntity extends DwOrmData {
    // Attributes
    VehicleAccidentId?: number;
    EmployeeId?: number;
    PhoneNumber?: string;
    WJID?: string;
    AccidentDateTime?: string;
    AuthorityContacted?: string;
    ReportNumber?: string;
    DriverStreetAddress?: string;
    DriverCity?: string;
    DriverState?: number;
    DriverZip?: string;
    AccidentAddress?: string;
    AccidentCity?: string;
    AccidentState?: number;
    AccidentZip?: string;
    AccidentTypeCv?: number;
    AccidentAtFaultCv?: number;
    VehicleRepairedCv?: number;
    Injuries?: boolean;
    OOPClaimExpense?: string;
    InsurancePaidPDLTInsuredVehicle?: string;
    InsurancePaidPDLTClaimantVehicle?: string;
    OtherVehiclesInvolved?: boolean;
    IsDot?: boolean;
    AccidentDescription?: string;
    AttachmentId?: number;
    ClaimNumber?: string;
    ClaimStatusCv?: number;
    ClaimInsuranceCompanyCv?: number;
    ClaimInsuranceCompanyText?: string;
    AdvisorName?: string;
    AdvisorPhone?: string;
    ClaimFiledDate?: string;
    ClaimComments?: string;
    CreatedbyEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    SharepointMigrationId?: number;
    AccidentDateMonth?: string;
    StateDisplay?: string;
    IsPoliceReportObtained?: boolean;
    ClaimNumberThirdParty?: string;


    // Relations
}

export interface RoVehicleYearsEntity extends DwOrmData {
    // Attributes
    Year?: number;


    // Relations
}

export interface ServiceTypeEntity extends DwOrmData {
    // Attributes
    ServiceTypeId?: number;
    Display?: string;


    // Relations
    MaintenanceService? : MaintenanceServiceEntity[];
}

export interface FleetVehicleEntity extends DwOrmData {
    // Attributes
    AdditionalDriverUserId?: number;
    AnnualInspectionExpirationDate?: string;
    CameraSerialNumber?: string;
    CreatedByDateTime?: string;
    CreatedByUserId?: number;
    DielectricInspectionExpirationDate?: string;
    DotInspectionDate?: string;
    DriverAlertId?: string;
    DriverUserId?: number;
    DriveTrainCv?: number;
    FuelCardId?: string;
    FuelTypeCv?: number;
    GpsId?: string;
    GVWR?: string;
    HasGps?: boolean;
    InsuranceExpirationDate?: string;
    IsDot?: boolean;
    IsEmployee?: boolean;
    JobNumberId?: number;
    LicensePlate?: string;
    Make?: string;
    MediaGroupId?: number;
    Model?: string;
    ModifiedByDateTime?: string;
    ModifiedByUserId?: number;
    NoteParentId?: number;
    OwnershipTypeCv?: number;
    PafEffectiveDate?: string;
    PafNotes?: string;
    PassAccountName?: string;
    PassAccountNumber?: string;
    PassActivationDate?: string;
    Phase?: string;
    PlateExpirationDate?: string;
    PurchaseDate?: string;
    PurchasePrice?: number;
    RawDriverName?: string;
    RegistrationStateProvinceId?: number;
    SendPaf?: boolean;
    SharepointId?: number;
    SpJobNumber?: string;
    TransponderSerialNumber?: string;
    UnitId?: string;
    VehicleId?: number;
    VehicleStatusCv?: number;
    VehicleTypeCv?: number;
    VIN?: string;
    WachterDepartmentId?: number;
    Year?: number;

    // Display Attributes
    AdditionalDriverUserIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    DriverUserIdDisplay?: string;
    DriveTrainCvDisplay?: string;
    FuelTypeCvDisplay?: string;
    JobNumberIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;
    NoteParentIdDisplay?: string;
    OwnershipTypeCvDisplay?: string;
    RegistrationStateProvinceIdDisplay?: string;
    VehicleStatusCvDisplay?: string;
    VehicleTypeCvDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    YearDisplay?: string;

    // Relations
    VehicleStatusCvCodeValue? : CodeValueEntity;
    VehicleTypeCvCodeValue? : CodeValueEntity;
    OwnershipTypeCvCodeValue? : CodeValueEntity;
    DriveTrainCvCodeValue? : CodeValueEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    DriverEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    AdditionalDriverEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    Auction? : AuctionEntity[];
    Maintenance? : MaintenanceEntity[];
    PafHistory? : PafHistoryEntity[];
    RoMaintenance? : RoMaintenanceEntity[];
    RoVehicle? : RoVehicleEntity[];
    // Duplicate property excluded
    // RoVehicle : RoVehicleEntity[];
}

// Generated Query Interfaces
/** Entity for Query Meaning Fleet_Auction_Grid_Query  */
export interface FleetAuctionGridQueryQueryEntity extends DwOrmData {
    // Attributes
    AuctionId?: number;
    CreatedByUserId?: number;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserId?: number;
    ModifiedByUserIdDisplay?: string;
    CreatedByDateTime?: string;
    ModifiedByDateTime?: string;
    SharepointId?: number;
    VehicleId?: number;
    VehicleIdDisplay?: string;
    Color?: string;
    Mileage?: number;
    ConditionCv?: number;
    ConditionCvDisplay?: string;
    Duration?: number;
    LegacyUnitId?: string;
    Description?: string;
    StatusCv?: number;
    StatusCvDisplay?: string;
    LocationCity?: string;
    LocationStateProvinceId?: number;
    LocationStateProvinceIdDisplay?: string;
    LocationZip?: string;
    StartingPrice?: number;
    Title?: string;
    EndDateTime?: string;
    StartDateTime?: string;
    FleetVehicleYear?: number;
    FleetVehicleYearDisplay?: string;
    FleetVehicleMake?: string;
    FleetVehicleModel?: string;
    FleetVehicleVehicleTypeCv?: number;
    FleetVehicleVehicleTypeCvDisplay?: string;
    RoVehicleUnitId?: string;
    RoVehicleUnitIdDisplay?: string;
    RoVehicleSortableUnitId?: number;
    RoVehicleWachterDepartmentId?: number;
    RoVehicleWachterDepartmentIdDisplay?: string;
    RoAuctionCurrentBid?: number;
    RoAuctionFinalBid?: number;

    // Relations
    ConditionCvCodeValue? : CodeValueEntity;
    StatusCvCodeValue? : CodeValueEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    FleetVehicle? : FleetVehicleEntity;
    BidHistory? : BidHistoryEntity[];
    RoAuction? : RoAuctionEntity[];
}

/** Entity for Query Meaning Fleet_Vehicle_Grid_Query  */
export interface FleetVehicleGridQueryQueryEntity extends DwOrmData {
    // Attributes
    AdditionalDriverUserId?: number;
    AdditionalDriverUserIdDisplay?: string;
    AnnualInspectionExpirationDate?: string;
    CameraSerialNumber?: string;
    CreatedByDateTime?: string;
    CreatedByUserId?: number;
    CreatedByUserIdDisplay?: string;
    DielectricInspectionExpirationDate?: string;
    DotInspectionDate?: string;
    DriverAlertId?: string;
    DriverUserId?: number;
    DriverUserIdDisplay?: string;
    DriveTrainCv?: number;
    DriveTrainCvDisplay?: string;
    FuelCardId?: string;
    FuelTypeCv?: number;
    FuelTypeCvDisplay?: string;
    GpsId?: string;
    GVWR?: string;
    HasGps?: boolean;
    InsuranceExpirationDate?: string;
    IsDot?: boolean;
    IsEmployee?: boolean;
    JobNumberId?: number;
    JobNumberIdDisplay?: string;
    LicensePlate?: string;
    Make?: string;
    MediaGroupId?: number;
    Model?: string;
    ModifiedByDateTime?: string;
    ModifiedByUserId?: number;
    ModifiedByUserIdDisplay?: string;
    NoteParentId?: number;
    NoteParentIdDisplay?: string;
    OwnershipTypeCv?: number;
    OwnershipTypeCvDisplay?: string;
    PafEffectiveDate?: string;
    PafNotes?: string;
    PassAccountName?: string;
    PassAccountNumber?: string;
    PassActivationDate?: string;
    Phase?: string;
    PlateExpirationDate?: string;
    PurchaseDate?: string;
    PurchasePrice?: number;
    RawDriverName?: string;
    RegistrationStateProvinceId?: number;
    RegistrationStateProvinceIdDisplay?: string;
    SendPaf?: boolean;
    SharepointId?: number;
    SpJobNumber?: string;
    TransponderSerialNumber?: string;
    UnitId?: string;
    VehicleId?: number;
    VehicleStatusCv?: number;
    VehicleStatusCvDisplay?: string;
    VehicleTypeCv?: number;
    VehicleTypeCvDisplay?: string;
    VIN?: string;
    WachterDepartmentId?: number;
    WachterDepartmentIdDisplay?: string;
    Year?: number;
    YearDisplay?: string;
    // Attribute DotInspectionDate is a duplicate and can't be included
    RoVehicleDriverName?: string;
    RoVehicleDriverNameDisplay?: string;
    RoVehicleSortableUnitId?: number;
    RoVehiclePhase?: string;
    RoVehicleIsDotDisplay?: string;
    RoVehicleUnassigned?: boolean;
    DepartmentMapGroup?: string;

    // Relations
    VehicleStatusCvCodeValue? : CodeValueEntity;
    VehicleTypeCvCodeValue? : CodeValueEntity;
    OwnershipTypeCvCodeValue? : CodeValueEntity;
    DriveTrainCvCodeValue? : CodeValueEntity;
    EthosJobNumber? : EthosJobNumberEntity;
    DriverEthosUser? : EthosUserEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
    AdditionalDriverEthosUser? : EthosUserEntity;
    EthosWachterDepartment? : EthosWachterDepartmentEntity;
    Auction? : AuctionEntity[];
    Maintenance? : MaintenanceEntity[];
    PafHistory? : PafHistoryEntity[];
    RoMaintenance? : RoMaintenanceEntity[];
    RoVehicle? : RoVehicleEntity[];
    // Duplicate property excluded
    // RoVehicle : RoVehicleEntity[];
}

    // Lookup Value Enums  {
export enum CodeValueFleetVehicleStatus {
        Donated = 103827,
        ForSale = 103829,
        OnLoan = 103830,
        Sold = 103831,
        Totaled = 103832,
        Active = 103841,
    }

export enum CodeValueFleetOwnershipType {
        Owned = 103833,
        Leased = 103834,
    }

export enum CodeValueFleetVehicleType {
        Bucket = 103821,
        Sedan = 103822,
        SUV = 103823,
        Trailer = 103824,
        Truck = 103825,
        Van = 103826,
    }

export enum CodeValueFleetDriveTrain {
        Num2WD = 103835,
        Num4WD = 103836,
        AWD = 103837,
    }

export enum CodeValueFleetFuelType {
        Diesel = 103838,
        Gasoline = 103839,
        None = 103840,
    }

export enum CodeValueFleetVehicleCondition {
        UsedExcellent = 103932,
        UsedFair = 103933,
        UsedGood = 103934,
        UsedPoor = 103935,
    }

// Excluding lookup Fleet Vehicle Unit ID because it contains 1339 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup Fleet Vehicle Driver because it contains 702 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum FleetVehicleYears {
        Num1980 = 1980,
        Num1981 = 1981,
        Num1982 = 1982,
        Num1983 = 1983,
        Num1984 = 1984,
        Num1985 = 1985,
        Num1986 = 1986,
        Num1987 = 1987,
        Num1988 = 1988,
        Num1989 = 1989,
        Num1990 = 1990,
        Num1991 = 1991,
        Num1992 = 1992,
        Num1993 = 1993,
        Num1994 = 1994,
        Num1995 = 1995,
        Num1996 = 1996,
        Num1997 = 1997,
        Num1998 = 1998,
        Num1999 = 1999,
        Num2000 = 2000,
        Num2001 = 2001,
        Num2002 = 2002,
        Num2003 = 2003,
        Num2004 = 2004,
        Num2005 = 2005,
        Num2006 = 2006,
        Num2007 = 2007,
        Num2008 = 2008,
        Num2009 = 2009,
        Num2010 = 2010,
        Num2011 = 2011,
        Num2012 = 2012,
        Num2013 = 2013,
        Num2014 = 2014,
        Num2015 = 2015,
        Num2016 = 2016,
        Num2017 = 2017,
        Num2018 = 2018,
        Num2019 = 2019,
        Num2020 = 2020,
        Num2021 = 2021,
        Num2022 = 2022,
        Num2023 = 2023,
        Num2024 = 2024,
        Num2025 = 2025,
    }

export enum CodeValueFleetAuctionStatus {
        ActiveOpen = 103936,
        Canceled = 103937,
        CompletedEnded = 103938,
        Sold = 103939,
        NotStartedNew = 103940,
    }

// Excluding lookup Fleet Vehicle Active Units Only because it contains 721 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum CodeValueFleetAuctionStatusNotStarted {
        Canceled = 103937,
        NotStartedNew = 103940,
    }

export enum CodeValueFleetAuctionStatusActive {
        ActiveOpen = 103936,
        Canceled = 103937,
    }

export enum CodeValueFleetAuctionStatusCompleted {
        CompletedEnded = 103938,
        Sold = 103939,
    }

// Excluding lookup Fleet Maintenance Driver because it contains 3109 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup Fleet Vehicle Units - All because it contains 1339 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup Fleet Vehicle VIN because it contains 1337 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup Fleet Vehicle Plate because it contains 1292 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup Fleet Vehicle Plate Expiration because it contains 199 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup Fleet Maintenance Plate because it contains 585 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
export enum FleetAuctionStatusWorkflow {
        ActiveOpen = 103936,
        Canceled = 103937,
        CompletedEnded = 103938,
        Sold = 103939,
        NotStartedNew = 103940,
    }

// Excluding lookup Fleet Vehicle Fuel Card because it contains 1088 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup Fleet Vehicle Driver Alert because it contains 989 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount
// Excluding lookup No Auction Fleet Vehicles because it contains 699 items which exceeds the max item setting of 100.  Override in cli config for code gen using ExcludeLookupsMaxCount



